var Hi = { exports: {} }, ll = {}, Wi = { exports: {} }, L = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jn = Symbol.for("react.element"), nc = Symbol.for("react.portal"), rc = Symbol.for("react.fragment"), lc = Symbol.for("react.strict_mode"), uc = Symbol.for("react.profiler"), oc = Symbol.for("react.provider"), ic = Symbol.for("react.context"), sc = Symbol.for("react.forward_ref"), ac = Symbol.for("react.suspense"), cc = Symbol.for("react.memo"), fc = Symbol.for("react.lazy"), Mo = Symbol.iterator;
function dc(e) {
  return e === null || typeof e != "object" ? null : (e = Mo && e[Mo] || e["@@iterator"], typeof e == "function" ? e : null);
}
var Qi = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, Ki = Object.assign, Yi = {};
function cn(e, t, n) {
  this.props = e, this.context = t, this.refs = Yi, this.updater = n || Qi;
}
cn.prototype.isReactComponent = {};
cn.prototype.setState = function(e, t) {
  if (typeof e != "object" && typeof e != "function" && e != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, t, "setState");
};
cn.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function Xi() {
}
Xi.prototype = cn.prototype;
function $u(e, t, n) {
  this.props = e, this.context = t, this.refs = Yi, this.updater = n || Qi;
}
var Au = $u.prototype = new Xi();
Au.constructor = $u;
Ki(Au, cn.prototype);
Au.isPureReactComponent = !0;
var Do = Array.isArray, Gi = Object.prototype.hasOwnProperty, Vu = { current: null }, Zi = { key: !0, ref: !0, __self: !0, __source: !0 };
function Ji(e, t, n) {
  var r, l = {}, u = null, o = null;
  if (t != null) for (r in t.ref !== void 0 && (o = t.ref), t.key !== void 0 && (u = "" + t.key), t) Gi.call(t, r) && !Zi.hasOwnProperty(r) && (l[r] = t[r]);
  var i = arguments.length - 2;
  if (i === 1) l.children = n;
  else if (1 < i) {
    for (var s = Array(i), c = 0; c < i; c++) s[c] = arguments[c + 2];
    l.children = s;
  }
  if (e && e.defaultProps) for (r in i = e.defaultProps, i) l[r] === void 0 && (l[r] = i[r]);
  return { $$typeof: Jn, type: e, key: u, ref: o, props: l, _owner: Vu.current };
}
function pc(e, t) {
  return { $$typeof: Jn, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function Bu(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Jn;
}
function mc(e) {
  var t = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(n) {
    return t[n];
  });
}
var Io = /\/+/g;
function Sl(e, t) {
  return typeof e == "object" && e !== null && e.key != null ? mc("" + e.key) : t.toString(36);
}
function xr(e, t, n, r, l) {
  var u = typeof e;
  (u === "undefined" || u === "boolean") && (e = null);
  var o = !1;
  if (e === null) o = !0;
  else switch (u) {
    case "string":
    case "number":
      o = !0;
      break;
    case "object":
      switch (e.$$typeof) {
        case Jn:
        case nc:
          o = !0;
      }
  }
  if (o) return o = e, l = l(o), e = r === "" ? "." + Sl(o, 0) : r, Do(l) ? (n = "", e != null && (n = e.replace(Io, "$&/") + "/"), xr(l, t, n, "", function(c) {
    return c;
  })) : l != null && (Bu(l) && (l = pc(l, n + (!l.key || o && o.key === l.key ? "" : ("" + l.key).replace(Io, "$&/") + "/") + e)), t.push(l)), 1;
  if (o = 0, r = r === "" ? "." : r + ":", Do(e)) for (var i = 0; i < e.length; i++) {
    u = e[i];
    var s = r + Sl(u, i);
    o += xr(u, t, n, s, l);
  }
  else if (s = dc(e), typeof s == "function") for (e = s.call(e), i = 0; !(u = e.next()).done; ) u = u.value, s = r + Sl(u, i++), o += xr(u, t, n, s, l);
  else if (u === "object") throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
  return o;
}
function ur(e, t, n) {
  if (e == null) return e;
  var r = [], l = 0;
  return xr(e, r, "", "", function(u) {
    return t.call(n, u, l++);
  }), r;
}
function hc(e) {
  if (e._status === -1) {
    var t = e._result;
    t = t(), t.then(function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = n);
    }, function(n) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = n);
    }), e._status === -1 && (e._status = 0, e._result = t);
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var fe = { current: null }, Er = { transition: null }, vc = { ReactCurrentDispatcher: fe, ReactCurrentBatchConfig: Er, ReactCurrentOwner: Vu };
function qi() {
  throw Error("act(...) is not supported in production builds of React.");
}
L.Children = { map: ur, forEach: function(e, t, n) {
  ur(e, function() {
    t.apply(this, arguments);
  }, n);
}, count: function(e) {
  var t = 0;
  return ur(e, function() {
    t++;
  }), t;
}, toArray: function(e) {
  return ur(e, function(t) {
    return t;
  }) || [];
}, only: function(e) {
  if (!Bu(e)) throw Error("React.Children.only expected to receive a single React element child.");
  return e;
} };
L.Component = cn;
L.Fragment = rc;
L.Profiler = uc;
L.PureComponent = $u;
L.StrictMode = lc;
L.Suspense = ac;
L.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vc;
L.act = qi;
L.cloneElement = function(e, t, n) {
  if (e == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var r = Ki({}, e.props), l = e.key, u = e.ref, o = e._owner;
  if (t != null) {
    if (t.ref !== void 0 && (u = t.ref, o = Vu.current), t.key !== void 0 && (l = "" + t.key), e.type && e.type.defaultProps) var i = e.type.defaultProps;
    for (s in t) Gi.call(t, s) && !Zi.hasOwnProperty(s) && (r[s] = t[s] === void 0 && i !== void 0 ? i[s] : t[s]);
  }
  var s = arguments.length - 2;
  if (s === 1) r.children = n;
  else if (1 < s) {
    i = Array(s);
    for (var c = 0; c < s; c++) i[c] = arguments[c + 2];
    r.children = i;
  }
  return { $$typeof: Jn, type: e.type, key: l, ref: u, props: r, _owner: o };
};
L.createContext = function(e) {
  return e = { $$typeof: ic, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, e.Provider = { $$typeof: oc, _context: e }, e.Consumer = e;
};
L.createElement = Ji;
L.createFactory = function(e) {
  var t = Ji.bind(null, e);
  return t.type = e, t;
};
L.createRef = function() {
  return { current: null };
};
L.forwardRef = function(e) {
  return { $$typeof: sc, render: e };
};
L.isValidElement = Bu;
L.lazy = function(e) {
  return { $$typeof: fc, _payload: { _status: -1, _result: e }, _init: hc };
};
L.memo = function(e, t) {
  return { $$typeof: cc, type: e, compare: t === void 0 ? null : t };
};
L.startTransition = function(e) {
  var t = Er.transition;
  Er.transition = {};
  try {
    e();
  } finally {
    Er.transition = t;
  }
};
L.unstable_act = qi;
L.useCallback = function(e, t) {
  return fe.current.useCallback(e, t);
};
L.useContext = function(e) {
  return fe.current.useContext(e);
};
L.useDebugValue = function() {
};
L.useDeferredValue = function(e) {
  return fe.current.useDeferredValue(e);
};
L.useEffect = function(e, t) {
  return fe.current.useEffect(e, t);
};
L.useId = function() {
  return fe.current.useId();
};
L.useImperativeHandle = function(e, t, n) {
  return fe.current.useImperativeHandle(e, t, n);
};
L.useInsertionEffect = function(e, t) {
  return fe.current.useInsertionEffect(e, t);
};
L.useLayoutEffect = function(e, t) {
  return fe.current.useLayoutEffect(e, t);
};
L.useMemo = function(e, t) {
  return fe.current.useMemo(e, t);
};
L.useReducer = function(e, t, n) {
  return fe.current.useReducer(e, t, n);
};
L.useRef = function(e) {
  return fe.current.useRef(e);
};
L.useState = function(e) {
  return fe.current.useState(e);
};
L.useSyncExternalStore = function(e, t, n) {
  return fe.current.useSyncExternalStore(e, t, n);
};
L.useTransition = function() {
  return fe.current.useTransition();
};
L.version = "18.3.1";
Wi.exports = L;
var Ce = Wi.exports;
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yc = Ce, gc = Symbol.for("react.element"), wc = Symbol.for("react.fragment"), kc = Object.prototype.hasOwnProperty, Sc = yc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, xc = { key: !0, ref: !0, __self: !0, __source: !0 };
function bi(e, t, n) {
  var r, l = {}, u = null, o = null;
  n !== void 0 && (u = "" + n), t.key !== void 0 && (u = "" + t.key), t.ref !== void 0 && (o = t.ref);
  for (r in t) kc.call(t, r) && !xc.hasOwnProperty(r) && (l[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps, t) l[r] === void 0 && (l[r] = t[r]);
  return { $$typeof: gc, type: e, key: u, ref: o, props: l, _owner: Sc.current };
}
ll.Fragment = wc;
ll.jsx = bi;
ll.jsxs = bi;
Hi.exports = ll;
var O = Hi.exports, es = { exports: {} }, xe = {}, ts = { exports: {} }, ns = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(e) {
  function t(S, P) {
    var z = S.length;
    S.push(P);
    e: for (; 0 < z; ) {
      var D = z - 1 >>> 1, J = S[D];
      if (0 < l(J, P)) S[D] = P, S[z] = J, z = D;
      else break e;
    }
  }
  function n(S) {
    return S.length === 0 ? null : S[0];
  }
  function r(S) {
    if (S.length === 0) return null;
    var P = S[0], z = S.pop();
    if (z !== P) {
      S[0] = z;
      e: for (var D = 0, J = S.length, rr = J >>> 1; D < rr; ) {
        var kt = 2 * (D + 1) - 1, kl = S[kt], St = kt + 1, lr = S[St];
        if (0 > l(kl, z)) St < J && 0 > l(lr, kl) ? (S[D] = lr, S[St] = z, D = St) : (S[D] = kl, S[kt] = z, D = kt);
        else if (St < J && 0 > l(lr, z)) S[D] = lr, S[St] = z, D = St;
        else break e;
      }
    }
    return P;
  }
  function l(S, P) {
    var z = S.sortIndex - P.sortIndex;
    return z !== 0 ? z : S.id - P.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var u = performance;
    e.unstable_now = function() {
      return u.now();
    };
  } else {
    var o = Date, i = o.now();
    e.unstable_now = function() {
      return o.now() - i;
    };
  }
  var s = [], c = [], h = 1, m = null, p = 3, g = !1, k = !1, w = !1, M = typeof setTimeout == "function" ? setTimeout : null, f = typeof clearTimeout == "function" ? clearTimeout : null, a = typeof setImmediate != "undefined" ? setImmediate : null;
  typeof navigator != "undefined" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function d(S) {
    for (var P = n(c); P !== null; ) {
      if (P.callback === null) r(c);
      else if (P.startTime <= S) r(c), P.sortIndex = P.expirationTime, t(s, P);
      else break;
      P = n(c);
    }
  }
  function v(S) {
    if (w = !1, d(S), !k) if (n(s) !== null) k = !0, It(x);
    else {
      var P = n(c);
      P !== null && se(v, P.startTime - S);
    }
  }
  function x(S, P) {
    k = !1, w && (w = !1, f(N), N = -1), g = !0;
    var z = p;
    try {
      for (d(P), m = n(s); m !== null && (!(m.expirationTime > P) || S && !I()); ) {
        var D = m.callback;
        if (typeof D == "function") {
          m.callback = null, p = m.priorityLevel;
          var J = D(m.expirationTime <= P);
          P = e.unstable_now(), typeof J == "function" ? m.callback = J : m === n(s) && r(s), d(P);
        } else r(s);
        m = n(s);
      }
      if (m !== null) var rr = !0;
      else {
        var kt = n(c);
        kt !== null && se(v, kt.startTime - P), rr = !1;
      }
      return rr;
    } finally {
      m = null, p = z, g = !1;
    }
  }
  var C = !1, _ = null, N = -1, V = 5, T = -1;
  function I() {
    return !(e.unstable_now() - T < V);
  }
  function Y() {
    if (_ !== null) {
      var S = e.unstable_now();
      T = S;
      var P = !0;
      try {
        P = _(!0, S);
      } finally {
        P ? ee() : (C = !1, _ = null);
      }
    } else C = !1;
  }
  var ee;
  if (typeof a == "function") ee = function() {
    a(Y);
  };
  else if (typeof MessageChannel != "undefined") {
    var Re = new MessageChannel(), nr = Re.port2;
    Re.port1.onmessage = Y, ee = function() {
      nr.postMessage(null);
    };
  } else ee = function() {
    M(Y, 0);
  };
  function It(S) {
    _ = S, C || (C = !0, ee());
  }
  function se(S, P) {
    N = M(function() {
      S(e.unstable_now());
    }, P);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(S) {
    S.callback = null;
  }, e.unstable_continueExecution = function() {
    k || g || (k = !0, It(x));
  }, e.unstable_forceFrameRate = function(S) {
    0 > S || 125 < S ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : V = 0 < S ? Math.floor(1e3 / S) : 5;
  }, e.unstable_getCurrentPriorityLevel = function() {
    return p;
  }, e.unstable_getFirstCallbackNode = function() {
    return n(s);
  }, e.unstable_next = function(S) {
    switch (p) {
      case 1:
      case 2:
      case 3:
        var P = 3;
        break;
      default:
        P = p;
    }
    var z = p;
    p = P;
    try {
      return S();
    } finally {
      p = z;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = function() {
  }, e.unstable_runWithPriority = function(S, P) {
    switch (S) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        S = 3;
    }
    var z = p;
    p = S;
    try {
      return P();
    } finally {
      p = z;
    }
  }, e.unstable_scheduleCallback = function(S, P, z) {
    var D = e.unstable_now();
    switch (typeof z == "object" && z !== null ? (z = z.delay, z = typeof z == "number" && 0 < z ? D + z : D) : z = D, S) {
      case 1:
        var J = -1;
        break;
      case 2:
        J = 250;
        break;
      case 5:
        J = 1073741823;
        break;
      case 4:
        J = 1e4;
        break;
      default:
        J = 5e3;
    }
    return J = z + J, S = { id: h++, callback: P, priorityLevel: S, startTime: z, expirationTime: J, sortIndex: -1 }, z > D ? (S.sortIndex = z, t(c, S), n(s) === null && S === n(c) && (w ? (f(N), N = -1) : w = !0, se(v, z - D))) : (S.sortIndex = J, t(s, S), k || g || (k = !0, It(x))), S;
  }, e.unstable_shouldYield = I, e.unstable_wrapCallback = function(S) {
    var P = p;
    return function() {
      var z = p;
      p = P;
      try {
        return S.apply(this, arguments);
      } finally {
        p = z;
      }
    };
  };
})(ns);
ts.exports = ns;
var Ec = ts.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cc = Ce, Se = Ec;
function y(e) {
  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var rs = /* @__PURE__ */ new Set(), Mn = {};
function Mt(e, t) {
  nn(e, t), nn(e + "Capture", t);
}
function nn(e, t) {
  for (Mn[e] = t, e = 0; e < t.length; e++) rs.add(t[e]);
}
var Ge = !(typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined"), Yl = Object.prototype.hasOwnProperty, _c = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Fo = {}, Uo = {};
function Nc(e) {
  return Yl.call(Uo, e) ? !0 : Yl.call(Fo, e) ? !1 : _c.test(e) ? Uo[e] = !0 : (Fo[e] = !0, !1);
}
function Pc(e, t, n, r) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof t) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r ? !1 : n !== null ? !n.acceptsBooleans : (e = e.toLowerCase().slice(0, 5), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function zc(e, t, n, r) {
  if (t === null || typeof t == "undefined" || Pc(e, t, n, r)) return !0;
  if (r) return !1;
  if (n !== null) switch (n.type) {
    case 3:
      return !t;
    case 4:
      return t === !1;
    case 5:
      return isNaN(t);
    case 6:
      return isNaN(t) || 1 > t;
  }
  return !1;
}
function de(e, t, n, r, l, u, o) {
  this.acceptsBooleans = t === 2 || t === 3 || t === 4, this.attributeName = r, this.attributeNamespace = l, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = u, this.removeEmptyString = o;
}
var re = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
  re[e] = new de(e, 0, !1, e, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = e[0];
  re[t] = new de(t, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  re[e] = new de(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  re[e] = new de(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  re[e] = new de(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function(e) {
  re[e] = new de(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function(e) {
  re[e] = new de(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function(e) {
  re[e] = new de(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  re[e] = new de(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var Hu = /[\-:]([a-z])/g;
function Wu(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  var t = e.replace(
    Hu,
    Wu
  );
  re[t] = new de(t, 1, !1, e, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  var t = e.replace(Hu, Wu);
  re[t] = new de(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  var t = e.replace(Hu, Wu);
  re[t] = new de(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  re[e] = new de(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
re.xlinkHref = new de("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function(e) {
  re[e] = new de(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function Qu(e, t, n, r) {
  var l = re.hasOwnProperty(t) ? re[t] : null;
  (l !== null ? l.type !== 0 : r || !(2 < t.length) || t[0] !== "o" && t[0] !== "O" || t[1] !== "n" && t[1] !== "N") && (zc(t, n, l, r) && (n = null), r || l === null ? Nc(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : l.mustUseProperty ? e[l.propertyName] = n === null ? l.type === 3 ? !1 : "" : n : (t = l.attributeName, r = l.attributeNamespace, n === null ? e.removeAttribute(t) : (l = l.type, n = l === 3 || l === 4 && n === !0 ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
}
var be = Cc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, or = Symbol.for("react.element"), Ut = Symbol.for("react.portal"), $t = Symbol.for("react.fragment"), Ku = Symbol.for("react.strict_mode"), Xl = Symbol.for("react.profiler"), ls = Symbol.for("react.provider"), us = Symbol.for("react.context"), Yu = Symbol.for("react.forward_ref"), Gl = Symbol.for("react.suspense"), Zl = Symbol.for("react.suspense_list"), Xu = Symbol.for("react.memo"), tt = Symbol.for("react.lazy"), os = Symbol.for("react.offscreen"), $o = Symbol.iterator;
function pn(e) {
  return e === null || typeof e != "object" ? null : (e = $o && e[$o] || e["@@iterator"], typeof e == "function" ? e : null);
}
var W = Object.assign, xl;
function Sn(e) {
  if (xl === void 0) try {
    throw Error();
  } catch (n) {
    var t = n.stack.trim().match(/\n( *(at )?)/);
    xl = t && t[1] || "";
  }
  return `
` + xl + e;
}
var El = !1;
function Cl(e, t) {
  if (!e || El) return "";
  El = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t) if (t = function() {
      throw Error();
    }, Object.defineProperty(t.prototype, "props", { set: function() {
      throw Error();
    } }), typeof Reflect == "object" && Reflect.construct) {
      try {
        Reflect.construct(t, []);
      } catch (c) {
        var r = c;
      }
      Reflect.construct(e, [], t);
    } else {
      try {
        t.call();
      } catch (c) {
        r = c;
      }
      e.call(t.prototype);
    }
    else {
      try {
        throw Error();
      } catch (c) {
        r = c;
      }
      e();
    }
  } catch (c) {
    if (c && r && typeof c.stack == "string") {
      for (var l = c.stack.split(`
`), u = r.stack.split(`
`), o = l.length - 1, i = u.length - 1; 1 <= o && 0 <= i && l[o] !== u[i]; ) i--;
      for (; 1 <= o && 0 <= i; o--, i--) if (l[o] !== u[i]) {
        if (o !== 1 || i !== 1)
          do
            if (o--, i--, 0 > i || l[o] !== u[i]) {
              var s = `
` + l[o].replace(" at new ", " at ");
              return e.displayName && s.includes("<anonymous>") && (s = s.replace("<anonymous>", e.displayName)), s;
            }
          while (1 <= o && 0 <= i);
        break;
      }
    }
  } finally {
    El = !1, Error.prepareStackTrace = n;
  }
  return (e = e ? e.displayName || e.name : "") ? Sn(e) : "";
}
function Tc(e) {
  switch (e.tag) {
    case 5:
      return Sn(e.type);
    case 16:
      return Sn("Lazy");
    case 13:
      return Sn("Suspense");
    case 19:
      return Sn("SuspenseList");
    case 0:
    case 2:
    case 15:
      return e = Cl(e.type, !1), e;
    case 11:
      return e = Cl(e.type.render, !1), e;
    case 1:
      return e = Cl(e.type, !0), e;
    default:
      return "";
  }
}
function Jl(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case $t:
      return "Fragment";
    case Ut:
      return "Portal";
    case Xl:
      return "Profiler";
    case Ku:
      return "StrictMode";
    case Gl:
      return "Suspense";
    case Zl:
      return "SuspenseList";
  }
  if (typeof e == "object") switch (e.$$typeof) {
    case us:
      return (e.displayName || "Context") + ".Consumer";
    case ls:
      return (e._context.displayName || "Context") + ".Provider";
    case Yu:
      var t = e.render;
      return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
    case Xu:
      return t = e.displayName || null, t !== null ? t : Jl(e.type) || "Memo";
    case tt:
      t = e._payload, e = e._init;
      try {
        return Jl(e(t));
      } catch {
      }
  }
  return null;
}
function Lc(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (t.displayName || "Context") + ".Consumer";
    case 10:
      return (t._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
    case 7:
      return "Fragment";
    case 5:
      return t;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return Jl(t);
    case 8:
      return t === Ku ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == "function") return t.displayName || t.name || null;
      if (typeof t == "string") return t;
  }
  return null;
}
function ht(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function is(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
}
function Rc(e) {
  var t = is(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), r = "" + e[t];
  if (!e.hasOwnProperty(t) && typeof n != "undefined" && typeof n.get == "function" && typeof n.set == "function") {
    var l = n.get, u = n.set;
    return Object.defineProperty(e, t, { configurable: !0, get: function() {
      return l.call(this);
    }, set: function(o) {
      r = "" + o, u.call(this, o);
    } }), Object.defineProperty(e, t, { enumerable: n.enumerable }), { getValue: function() {
      return r;
    }, setValue: function(o) {
      r = "" + o;
    }, stopTracking: function() {
      e._valueTracker = null, delete e[t];
    } };
  }
}
function ir(e) {
  e._valueTracker || (e._valueTracker = Rc(e));
}
function ss(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(), r = "";
  return e && (r = is(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n ? (t.setValue(e), !0) : !1;
}
function Mr(e) {
  if (e = e || (typeof document != "undefined" ? document : void 0), typeof e == "undefined") return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function ql(e, t) {
  var n = t.checked;
  return W({}, t, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: n != null ? n : e._wrapperState.initialChecked });
}
function Ao(e, t) {
  var n = t.defaultValue == null ? "" : t.defaultValue, r = t.checked != null ? t.checked : t.defaultChecked;
  n = ht(t.value != null ? t.value : n), e._wrapperState = { initialChecked: r, initialValue: n, controlled: t.type === "checkbox" || t.type === "radio" ? t.checked != null : t.value != null };
}
function as(e, t) {
  t = t.checked, t != null && Qu(e, "checked", t, !1);
}
function bl(e, t) {
  as(e, t);
  var n = ht(t.value), r = t.type;
  if (n != null) r === "number" ? (n === 0 && e.value === "" || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
  else if (r === "submit" || r === "reset") {
    e.removeAttribute("value");
    return;
  }
  t.hasOwnProperty("value") ? eu(e, t.type, n) : t.hasOwnProperty("defaultValue") && eu(e, t.type, ht(t.defaultValue)), t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function Vo(e, t, n) {
  if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
    var r = t.type;
    if (!(r !== "submit" && r !== "reset" || t.value !== void 0 && t.value !== null)) return;
    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
  }
  n = e.name, n !== "" && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, n !== "" && (e.name = n);
}
function eu(e, t, n) {
  (t !== "number" || Mr(e.ownerDocument) !== e) && (n == null ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
}
var xn = Array.isArray;
function Zt(e, t, n, r) {
  if (e = e.options, t) {
    t = {};
    for (var l = 0; l < n.length; l++) t["$" + n[l]] = !0;
    for (n = 0; n < e.length; n++) l = t.hasOwnProperty("$" + e[n].value), e[n].selected !== l && (e[n].selected = l), l && r && (e[n].defaultSelected = !0);
  } else {
    for (n = "" + ht(n), t = null, l = 0; l < e.length; l++) {
      if (e[l].value === n) {
        e[l].selected = !0, r && (e[l].defaultSelected = !0);
        return;
      }
      t !== null || e[l].disabled || (t = e[l]);
    }
    t !== null && (t.selected = !0);
  }
}
function tu(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(y(91));
  return W({}, t, { value: void 0, defaultValue: void 0, children: "" + e._wrapperState.initialValue });
}
function Bo(e, t) {
  var n = t.value;
  if (n == null) {
    if (n = t.children, t = t.defaultValue, n != null) {
      if (t != null) throw Error(y(92));
      if (xn(n)) {
        if (1 < n.length) throw Error(y(93));
        n = n[0];
      }
      t = n;
    }
    t == null && (t = ""), n = t;
  }
  e._wrapperState = { initialValue: ht(n) };
}
function cs(e, t) {
  var n = ht(t.value), r = ht(t.defaultValue);
  n != null && (n = "" + n, n !== e.value && (e.value = n), t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)), r != null && (e.defaultValue = "" + r);
}
function Ho(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== "" && t !== null && (e.value = t);
}
function fs(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function nu(e, t) {
  return e == null || e === "http://www.w3.org/1999/xhtml" ? fs(t) : e === "http://www.w3.org/2000/svg" && t === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e;
}
var sr, ds = function(e) {
  return typeof MSApp != "undefined" && MSApp.execUnsafeLocalFunction ? function(t, n, r, l) {
    MSApp.execUnsafeLocalFunction(function() {
      return e(t, n, r, l);
    });
  } : e;
}(function(e, t) {
  if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e) e.innerHTML = t;
  else {
    for (sr = sr || document.createElement("div"), sr.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = sr.firstChild; e.firstChild; ) e.removeChild(e.firstChild);
    for (; t.firstChild; ) e.appendChild(t.firstChild);
  }
});
function Dn(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var _n = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, Oc = ["Webkit", "ms", "Moz", "O"];
Object.keys(_n).forEach(function(e) {
  Oc.forEach(function(t) {
    t = t + e.charAt(0).toUpperCase() + e.substring(1), _n[t] = _n[e];
  });
});
function ps(e, t, n) {
  return t == null || typeof t == "boolean" || t === "" ? "" : n || typeof t != "number" || t === 0 || _n.hasOwnProperty(e) && _n[e] ? ("" + t).trim() : t + "px";
}
function ms(e, t) {
  e = e.style;
  for (var n in t) if (t.hasOwnProperty(n)) {
    var r = n.indexOf("--") === 0, l = ps(n, t[n], r);
    n === "float" && (n = "cssFloat"), r ? e.setProperty(n, l) : e[n] = l;
  }
}
var jc = W({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function ru(e, t) {
  if (t) {
    if (jc[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(y(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(y(60));
      if (typeof t.dangerouslySetInnerHTML != "object" || !("__html" in t.dangerouslySetInnerHTML)) throw Error(y(61));
    }
    if (t.style != null && typeof t.style != "object") throw Error(y(62));
  }
}
function lu(e, t) {
  if (e.indexOf("-") === -1) return typeof t.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var uu = null;
function Gu(e) {
  return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
}
var ou = null, Jt = null, qt = null;
function Wo(e) {
  if (e = er(e)) {
    if (typeof ou != "function") throw Error(y(280));
    var t = e.stateNode;
    t && (t = al(t), ou(e.stateNode, e.type, t));
  }
}
function hs(e) {
  Jt ? qt ? qt.push(e) : qt = [e] : Jt = e;
}
function vs() {
  if (Jt) {
    var e = Jt, t = qt;
    if (qt = Jt = null, Wo(e), t) for (e = 0; e < t.length; e++) Wo(t[e]);
  }
}
function ys(e, t) {
  return e(t);
}
function gs() {
}
var _l = !1;
function ws(e, t, n) {
  if (_l) return e(t, n);
  _l = !0;
  try {
    return ys(e, t, n);
  } finally {
    _l = !1, (Jt !== null || qt !== null) && (gs(), vs());
  }
}
function In(e, t) {
  var n = e.stateNode;
  if (n === null) return null;
  var r = al(n);
  if (r === null) return null;
  n = r[t];
  e: switch (t) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && typeof n != "function") throw Error(y(231, t, typeof n));
  return n;
}
var iu = !1;
if (Ge) try {
  var mn = {};
  Object.defineProperty(mn, "passive", { get: function() {
    iu = !0;
  } }), window.addEventListener("test", mn, mn), window.removeEventListener("test", mn, mn);
} catch {
  iu = !1;
}
function Mc(e, t, n, r, l, u, o, i, s) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, c);
  } catch (h) {
    this.onError(h);
  }
}
var Nn = !1, Dr = null, Ir = !1, su = null, Dc = { onError: function(e) {
  Nn = !0, Dr = e;
} };
function Ic(e, t, n, r, l, u, o, i, s) {
  Nn = !1, Dr = null, Mc.apply(Dc, arguments);
}
function Fc(e, t, n, r, l, u, o, i, s) {
  if (Ic.apply(this, arguments), Nn) {
    if (Nn) {
      var c = Dr;
      Nn = !1, Dr = null;
    } else throw Error(y(198));
    Ir || (Ir = !0, su = c);
  }
}
function Dt(e) {
  var t = e, n = e;
  if (e.alternate) for (; t.return; ) t = t.return;
  else {
    e = t;
    do
      t = e, t.flags & 4098 && (n = t.return), e = t.return;
    while (e);
  }
  return t.tag === 3 ? n : null;
}
function ks(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
  }
  return null;
}
function Qo(e) {
  if (Dt(e) !== e) throw Error(y(188));
}
function Uc(e) {
  var t = e.alternate;
  if (!t) {
    if (t = Dt(e), t === null) throw Error(y(188));
    return t !== e ? null : e;
  }
  for (var n = e, r = t; ; ) {
    var l = n.return;
    if (l === null) break;
    var u = l.alternate;
    if (u === null) {
      if (r = l.return, r !== null) {
        n = r;
        continue;
      }
      break;
    }
    if (l.child === u.child) {
      for (u = l.child; u; ) {
        if (u === n) return Qo(l), e;
        if (u === r) return Qo(l), t;
        u = u.sibling;
      }
      throw Error(y(188));
    }
    if (n.return !== r.return) n = l, r = u;
    else {
      for (var o = !1, i = l.child; i; ) {
        if (i === n) {
          o = !0, n = l, r = u;
          break;
        }
        if (i === r) {
          o = !0, r = l, n = u;
          break;
        }
        i = i.sibling;
      }
      if (!o) {
        for (i = u.child; i; ) {
          if (i === n) {
            o = !0, n = u, r = l;
            break;
          }
          if (i === r) {
            o = !0, r = u, n = l;
            break;
          }
          i = i.sibling;
        }
        if (!o) throw Error(y(189));
      }
    }
    if (n.alternate !== r) throw Error(y(190));
  }
  if (n.tag !== 3) throw Error(y(188));
  return n.stateNode.current === n ? e : t;
}
function Ss(e) {
  return e = Uc(e), e !== null ? xs(e) : null;
}
function xs(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var t = xs(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var Es = Se.unstable_scheduleCallback, Ko = Se.unstable_cancelCallback, $c = Se.unstable_shouldYield, Ac = Se.unstable_requestPaint, K = Se.unstable_now, Vc = Se.unstable_getCurrentPriorityLevel, Zu = Se.unstable_ImmediatePriority, Cs = Se.unstable_UserBlockingPriority, Fr = Se.unstable_NormalPriority, Bc = Se.unstable_LowPriority, _s = Se.unstable_IdlePriority, ul = null, Be = null;
function Hc(e) {
  if (Be && typeof Be.onCommitFiberRoot == "function") try {
    Be.onCommitFiberRoot(ul, e, void 0, (e.current.flags & 128) === 128);
  } catch {
  }
}
var Ie = Math.clz32 ? Math.clz32 : Kc, Wc = Math.log, Qc = Math.LN2;
function Kc(e) {
  return e >>>= 0, e === 0 ? 32 : 31 - (Wc(e) / Qc | 0) | 0;
}
var ar = 64, cr = 4194304;
function En(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function Ur(e, t) {
  var n = e.pendingLanes;
  if (n === 0) return 0;
  var r = 0, l = e.suspendedLanes, u = e.pingedLanes, o = n & 268435455;
  if (o !== 0) {
    var i = o & ~l;
    i !== 0 ? r = En(i) : (u &= o, u !== 0 && (r = En(u)));
  } else o = n & ~l, o !== 0 ? r = En(o) : u !== 0 && (r = En(u));
  if (r === 0) return 0;
  if (t !== 0 && t !== r && !(t & l) && (l = r & -r, u = t & -t, l >= u || l === 16 && (u & 4194240) !== 0)) return t;
  if (r & 4 && (r |= n & 16), t = e.entangledLanes, t !== 0) for (e = e.entanglements, t &= r; 0 < t; ) n = 31 - Ie(t), l = 1 << n, r |= e[n], t &= ~l;
  return r;
}
function Yc(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function Xc(e, t) {
  for (var n = e.suspendedLanes, r = e.pingedLanes, l = e.expirationTimes, u = e.pendingLanes; 0 < u; ) {
    var o = 31 - Ie(u), i = 1 << o, s = l[o];
    s === -1 ? (!(i & n) || i & r) && (l[o] = Yc(i, t)) : s <= t && (e.expiredLanes |= i), u &= ~i;
  }
}
function au(e) {
  return e = e.pendingLanes & -1073741825, e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function Ns() {
  var e = ar;
  return ar <<= 1, !(ar & 4194240) && (ar = 64), e;
}
function Nl(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function qn(e, t, n) {
  e.pendingLanes |= t, t !== 536870912 && (e.suspendedLanes = 0, e.pingedLanes = 0), e = e.eventTimes, t = 31 - Ie(t), e[t] = n;
}
function Gc(e, t) {
  var n = e.pendingLanes & ~t;
  e.pendingLanes = t, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t, t = e.entanglements;
  var r = e.eventTimes;
  for (e = e.expirationTimes; 0 < n; ) {
    var l = 31 - Ie(n), u = 1 << l;
    t[l] = 0, r[l] = -1, e[l] = -1, n &= ~u;
  }
}
function Ju(e, t) {
  var n = e.entangledLanes |= t;
  for (e = e.entanglements; n; ) {
    var r = 31 - Ie(n), l = 1 << r;
    l & t | e[r] & t && (e[r] |= t), n &= ~l;
  }
}
var j = 0;
function Ps(e) {
  return e &= -e, 1 < e ? 4 < e ? e & 268435455 ? 16 : 536870912 : 4 : 1;
}
var zs, qu, Ts, Ls, Rs, cu = !1, fr = [], it = null, st = null, at = null, Fn = /* @__PURE__ */ new Map(), Un = /* @__PURE__ */ new Map(), rt = [], Zc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Yo(e, t) {
  switch (e) {
    case "focusin":
    case "focusout":
      it = null;
      break;
    case "dragenter":
    case "dragleave":
      st = null;
      break;
    case "mouseover":
    case "mouseout":
      at = null;
      break;
    case "pointerover":
    case "pointerout":
      Fn.delete(t.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Un.delete(t.pointerId);
  }
}
function hn(e, t, n, r, l, u) {
  return e === null || e.nativeEvent !== u ? (e = { blockedOn: t, domEventName: n, eventSystemFlags: r, nativeEvent: u, targetContainers: [l] }, t !== null && (t = er(t), t !== null && qu(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, l !== null && t.indexOf(l) === -1 && t.push(l), e);
}
function Jc(e, t, n, r, l) {
  switch (t) {
    case "focusin":
      return it = hn(it, e, t, n, r, l), !0;
    case "dragenter":
      return st = hn(st, e, t, n, r, l), !0;
    case "mouseover":
      return at = hn(at, e, t, n, r, l), !0;
    case "pointerover":
      var u = l.pointerId;
      return Fn.set(u, hn(Fn.get(u) || null, e, t, n, r, l)), !0;
    case "gotpointercapture":
      return u = l.pointerId, Un.set(u, hn(Un.get(u) || null, e, t, n, r, l)), !0;
  }
  return !1;
}
function Os(e) {
  var t = Ct(e.target);
  if (t !== null) {
    var n = Dt(t);
    if (n !== null) {
      if (t = n.tag, t === 13) {
        if (t = ks(n), t !== null) {
          e.blockedOn = t, Rs(e.priority, function() {
            Ts(n);
          });
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function Cr(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var n = fu(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var r = new n.constructor(n.type, n);
      uu = r, n.target.dispatchEvent(r), uu = null;
    } else return t = er(n), t !== null && qu(t), e.blockedOn = n, !1;
    t.shift();
  }
  return !0;
}
function Xo(e, t, n) {
  Cr(e) && n.delete(t);
}
function qc() {
  cu = !1, it !== null && Cr(it) && (it = null), st !== null && Cr(st) && (st = null), at !== null && Cr(at) && (at = null), Fn.forEach(Xo), Un.forEach(Xo);
}
function vn(e, t) {
  e.blockedOn === t && (e.blockedOn = null, cu || (cu = !0, Se.unstable_scheduleCallback(Se.unstable_NormalPriority, qc)));
}
function $n(e) {
  function t(l) {
    return vn(l, e);
  }
  if (0 < fr.length) {
    vn(fr[0], e);
    for (var n = 1; n < fr.length; n++) {
      var r = fr[n];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (it !== null && vn(it, e), st !== null && vn(st, e), at !== null && vn(at, e), Fn.forEach(t), Un.forEach(t), n = 0; n < rt.length; n++) r = rt[n], r.blockedOn === e && (r.blockedOn = null);
  for (; 0 < rt.length && (n = rt[0], n.blockedOn === null); ) Os(n), n.blockedOn === null && rt.shift();
}
var bt = be.ReactCurrentBatchConfig, $r = !0;
function bc(e, t, n, r) {
  var l = j, u = bt.transition;
  bt.transition = null;
  try {
    j = 1, bu(e, t, n, r);
  } finally {
    j = l, bt.transition = u;
  }
}
function ef(e, t, n, r) {
  var l = j, u = bt.transition;
  bt.transition = null;
  try {
    j = 4, bu(e, t, n, r);
  } finally {
    j = l, bt.transition = u;
  }
}
function bu(e, t, n, r) {
  if ($r) {
    var l = fu(e, t, n, r);
    if (l === null) Il(e, t, r, Ar, n), Yo(e, r);
    else if (Jc(l, e, t, n, r)) r.stopPropagation();
    else if (Yo(e, r), t & 4 && -1 < Zc.indexOf(e)) {
      for (; l !== null; ) {
        var u = er(l);
        if (u !== null && zs(u), u = fu(e, t, n, r), u === null && Il(e, t, r, Ar, n), u === l) break;
        l = u;
      }
      l !== null && r.stopPropagation();
    } else Il(e, t, r, null, n);
  }
}
var Ar = null;
function fu(e, t, n, r) {
  if (Ar = null, e = Gu(r), e = Ct(e), e !== null) if (t = Dt(e), t === null) e = null;
  else if (n = t.tag, n === 13) {
    if (e = ks(t), e !== null) return e;
    e = null;
  } else if (n === 3) {
    if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
    e = null;
  } else t !== e && (e = null);
  return Ar = e, null;
}
function js(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (Vc()) {
        case Zu:
          return 1;
        case Cs:
          return 4;
        case Fr:
        case Bc:
          return 16;
        case _s:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var ut = null, eo = null, _r = null;
function Ms() {
  if (_r) return _r;
  var e, t = eo, n = t.length, r, l = "value" in ut ? ut.value : ut.textContent, u = l.length;
  for (e = 0; e < n && t[e] === l[e]; e++) ;
  var o = n - e;
  for (r = 1; r <= o && t[n - r] === l[u - r]; r++) ;
  return _r = l.slice(e, 1 < r ? 1 - r : void 0);
}
function Nr(e) {
  var t = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function dr() {
  return !0;
}
function Go() {
  return !1;
}
function Ee(e) {
  function t(n, r, l, u, o) {
    this._reactName = n, this._targetInst = l, this.type = r, this.nativeEvent = u, this.target = o, this.currentTarget = null;
    for (var i in e) e.hasOwnProperty(i) && (n = e[i], this[i] = n ? n(u) : u[i]);
    return this.isDefaultPrevented = (u.defaultPrevented != null ? u.defaultPrevented : u.returnValue === !1) ? dr : Go, this.isPropagationStopped = Go, this;
  }
  return W(t.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var n = this.nativeEvent;
    n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = dr);
  }, stopPropagation: function() {
    var n = this.nativeEvent;
    n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = dr);
  }, persist: function() {
  }, isPersistent: dr }), t;
}
var fn = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
  return e.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, to = Ee(fn), bn = W({}, fn, { view: 0, detail: 0 }), tf = Ee(bn), Pl, zl, yn, ol = W({}, bn, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: no, button: 0, buttons: 0, relatedTarget: function(e) {
  return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
}, movementX: function(e) {
  return "movementX" in e ? e.movementX : (e !== yn && (yn && e.type === "mousemove" ? (Pl = e.screenX - yn.screenX, zl = e.screenY - yn.screenY) : zl = Pl = 0, yn = e), Pl);
}, movementY: function(e) {
  return "movementY" in e ? e.movementY : zl;
} }), Zo = Ee(ol), nf = W({}, ol, { dataTransfer: 0 }), rf = Ee(nf), lf = W({}, bn, { relatedTarget: 0 }), Tl = Ee(lf), uf = W({}, fn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), of = Ee(uf), sf = W({}, fn, { clipboardData: function(e) {
  return "clipboardData" in e ? e.clipboardData : window.clipboardData;
} }), af = Ee(sf), cf = W({}, fn, { data: 0 }), Jo = Ee(cf), ff = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, df = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, pf = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function mf(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = pf[e]) ? !!t[e] : !1;
}
function no() {
  return mf;
}
var hf = W({}, bn, { key: function(e) {
  if (e.key) {
    var t = ff[e.key] || e.key;
    if (t !== "Unidentified") return t;
  }
  return e.type === "keypress" ? (e = Nr(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? df[e.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: no, charCode: function(e) {
  return e.type === "keypress" ? Nr(e) : 0;
}, keyCode: function(e) {
  return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
}, which: function(e) {
  return e.type === "keypress" ? Nr(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
} }), vf = Ee(hf), yf = W({}, ol, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), qo = Ee(yf), gf = W({}, bn, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: no }), wf = Ee(gf), kf = W({}, fn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Sf = Ee(kf), xf = W({}, ol, {
  deltaX: function(e) {
    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
  },
  deltaY: function(e) {
    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), Ef = Ee(xf), Cf = [9, 13, 27, 32], ro = Ge && "CompositionEvent" in window, Pn = null;
Ge && "documentMode" in document && (Pn = document.documentMode);
var _f = Ge && "TextEvent" in window && !Pn, Ds = Ge && (!ro || Pn && 8 < Pn && 11 >= Pn), bo = " ", ei = !1;
function Is(e, t) {
  switch (e) {
    case "keyup":
      return Cf.indexOf(t.keyCode) !== -1;
    case "keydown":
      return t.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function Fs(e) {
  return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
}
var At = !1;
function Nf(e, t) {
  switch (e) {
    case "compositionend":
      return Fs(t);
    case "keypress":
      return t.which !== 32 ? null : (ei = !0, bo);
    case "textInput":
      return e = t.data, e === bo && ei ? null : e;
    default:
      return null;
  }
}
function Pf(e, t) {
  if (At) return e === "compositionend" || !ro && Is(e, t) ? (e = Ms(), _r = eo = ut = null, At = !1, e) : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case "compositionend":
      return Ds && t.locale !== "ko" ? null : t.data;
    default:
      return null;
  }
}
var zf = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
function ti(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === "input" ? !!zf[e.type] : t === "textarea";
}
function Us(e, t, n, r) {
  hs(r), t = Vr(t, "onChange"), 0 < t.length && (n = new to("onChange", "change", null, n, r), e.push({ event: n, listeners: t }));
}
var zn = null, An = null;
function Tf(e) {
  Gs(e, 0);
}
function il(e) {
  var t = Ht(e);
  if (ss(t)) return e;
}
function Lf(e, t) {
  if (e === "change") return t;
}
var $s = !1;
if (Ge) {
  var Ll;
  if (Ge) {
    var Rl = "oninput" in document;
    if (!Rl) {
      var ni = document.createElement("div");
      ni.setAttribute("oninput", "return;"), Rl = typeof ni.oninput == "function";
    }
    Ll = Rl;
  } else Ll = !1;
  $s = Ll && (!document.documentMode || 9 < document.documentMode);
}
function ri() {
  zn && (zn.detachEvent("onpropertychange", As), An = zn = null);
}
function As(e) {
  if (e.propertyName === "value" && il(An)) {
    var t = [];
    Us(t, An, e, Gu(e)), ws(Tf, t);
  }
}
function Rf(e, t, n) {
  e === "focusin" ? (ri(), zn = t, An = n, zn.attachEvent("onpropertychange", As)) : e === "focusout" && ri();
}
function Of(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown") return il(An);
}
function jf(e, t) {
  if (e === "click") return il(t);
}
function Mf(e, t) {
  if (e === "input" || e === "change") return il(t);
}
function Df(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Ue = typeof Object.is == "function" ? Object.is : Df;
function Vn(e, t) {
  if (Ue(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (r = 0; r < n.length; r++) {
    var l = n[r];
    if (!Yl.call(t, l) || !Ue(e[l], t[l])) return !1;
  }
  return !0;
}
function li(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function ui(e, t) {
  var n = li(e);
  e = 0;
  for (var r; n; ) {
    if (n.nodeType === 3) {
      if (r = e + n.textContent.length, e <= t && r >= t) return { node: n, offset: t - e };
      e = r;
    }
    e: {
      for (; n; ) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = li(n);
  }
}
function Vs(e, t) {
  return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? Vs(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
}
function Bs() {
  for (var e = window, t = Mr(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var n = typeof t.contentWindow.location.href == "string";
    } catch {
      n = !1;
    }
    if (n) e = t.contentWindow;
    else break;
    t = Mr(e.document);
  }
  return t;
}
function lo(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
}
function If(e) {
  var t = Bs(), n = e.focusedElem, r = e.selectionRange;
  if (t !== n && n && n.ownerDocument && Vs(n.ownerDocument.documentElement, n)) {
    if (r !== null && lo(n)) {
      if (t = r.start, e = r.end, e === void 0 && (e = t), "selectionStart" in n) n.selectionStart = t, n.selectionEnd = Math.min(e, n.value.length);
      else if (e = (t = n.ownerDocument || document) && t.defaultView || window, e.getSelection) {
        e = e.getSelection();
        var l = n.textContent.length, u = Math.min(r.start, l);
        r = r.end === void 0 ? u : Math.min(r.end, l), !e.extend && u > r && (l = r, r = u, u = l), l = ui(n, u);
        var o = ui(
          n,
          r
        );
        l && o && (e.rangeCount !== 1 || e.anchorNode !== l.node || e.anchorOffset !== l.offset || e.focusNode !== o.node || e.focusOffset !== o.offset) && (t = t.createRange(), t.setStart(l.node, l.offset), e.removeAllRanges(), u > r ? (e.addRange(t), e.extend(o.node, o.offset)) : (t.setEnd(o.node, o.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; e = e.parentNode; ) e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof n.focus == "function" && n.focus(), n = 0; n < t.length; n++) e = t[n], e.element.scrollLeft = e.left, e.element.scrollTop = e.top;
  }
}
var Ff = Ge && "documentMode" in document && 11 >= document.documentMode, Vt = null, du = null, Tn = null, pu = !1;
function oi(e, t, n) {
  var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  pu || Vt == null || Vt !== Mr(r) || (r = Vt, "selectionStart" in r && lo(r) ? r = { start: r.selectionStart, end: r.selectionEnd } : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = { anchorNode: r.anchorNode, anchorOffset: r.anchorOffset, focusNode: r.focusNode, focusOffset: r.focusOffset }), Tn && Vn(Tn, r) || (Tn = r, r = Vr(du, "onSelect"), 0 < r.length && (t = new to("onSelect", "select", null, t, n), e.push({ event: t, listeners: r }), t.target = Vt)));
}
function pr(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
}
var Bt = { animationend: pr("Animation", "AnimationEnd"), animationiteration: pr("Animation", "AnimationIteration"), animationstart: pr("Animation", "AnimationStart"), transitionend: pr("Transition", "TransitionEnd") }, Ol = {}, Hs = {};
Ge && (Hs = document.createElement("div").style, "AnimationEvent" in window || (delete Bt.animationend.animation, delete Bt.animationiteration.animation, delete Bt.animationstart.animation), "TransitionEvent" in window || delete Bt.transitionend.transition);
function sl(e) {
  if (Ol[e]) return Ol[e];
  if (!Bt[e]) return e;
  var t = Bt[e], n;
  for (n in t) if (t.hasOwnProperty(n) && n in Hs) return Ol[e] = t[n];
  return e;
}
var Ws = sl("animationend"), Qs = sl("animationiteration"), Ks = sl("animationstart"), Ys = sl("transitionend"), Xs = /* @__PURE__ */ new Map(), ii = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function yt(e, t) {
  Xs.set(e, t), Mt(t, [e]);
}
for (var jl = 0; jl < ii.length; jl++) {
  var Ml = ii[jl], Uf = Ml.toLowerCase(), $f = Ml[0].toUpperCase() + Ml.slice(1);
  yt(Uf, "on" + $f);
}
yt(Ws, "onAnimationEnd");
yt(Qs, "onAnimationIteration");
yt(Ks, "onAnimationStart");
yt("dblclick", "onDoubleClick");
yt("focusin", "onFocus");
yt("focusout", "onBlur");
yt(Ys, "onTransitionEnd");
nn("onMouseEnter", ["mouseout", "mouseover"]);
nn("onMouseLeave", ["mouseout", "mouseover"]);
nn("onPointerEnter", ["pointerout", "pointerover"]);
nn("onPointerLeave", ["pointerout", "pointerover"]);
Mt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
Mt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
Mt("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
Mt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
Mt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
Mt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Cn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Af = new Set("cancel close invalid load scroll toggle".split(" ").concat(Cn));
function si(e, t, n) {
  var r = e.type || "unknown-event";
  e.currentTarget = n, Fc(r, t, void 0, e), e.currentTarget = null;
}
function Gs(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], l = r.event;
    r = r.listeners;
    e: {
      var u = void 0;
      if (t) for (var o = r.length - 1; 0 <= o; o--) {
        var i = r[o], s = i.instance, c = i.currentTarget;
        if (i = i.listener, s !== u && l.isPropagationStopped()) break e;
        si(l, i, c), u = s;
      }
      else for (o = 0; o < r.length; o++) {
        if (i = r[o], s = i.instance, c = i.currentTarget, i = i.listener, s !== u && l.isPropagationStopped()) break e;
        si(l, i, c), u = s;
      }
    }
  }
  if (Ir) throw e = su, Ir = !1, su = null, e;
}
function U(e, t) {
  var n = t[gu];
  n === void 0 && (n = t[gu] = /* @__PURE__ */ new Set());
  var r = e + "__bubble";
  n.has(r) || (Zs(t, e, 2, !1), n.add(r));
}
function Dl(e, t, n) {
  var r = 0;
  t && (r |= 4), Zs(n, e, r, t);
}
var mr = "_reactListening" + Math.random().toString(36).slice(2);
function Bn(e) {
  if (!e[mr]) {
    e[mr] = !0, rs.forEach(function(n) {
      n !== "selectionchange" && (Af.has(n) || Dl(n, !1, e), Dl(n, !0, e));
    });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[mr] || (t[mr] = !0, Dl("selectionchange", !1, t));
  }
}
function Zs(e, t, n, r) {
  switch (js(t)) {
    case 1:
      var l = bc;
      break;
    case 4:
      l = ef;
      break;
    default:
      l = bu;
  }
  n = l.bind(null, t, n, e), l = void 0, !iu || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (l = !0), r ? l !== void 0 ? e.addEventListener(t, n, { capture: !0, passive: l }) : e.addEventListener(t, n, !0) : l !== void 0 ? e.addEventListener(t, n, { passive: l }) : e.addEventListener(t, n, !1);
}
function Il(e, t, n, r, l) {
  var u = r;
  if (!(t & 1) && !(t & 2) && r !== null) e: for (; ; ) {
    if (r === null) return;
    var o = r.tag;
    if (o === 3 || o === 4) {
      var i = r.stateNode.containerInfo;
      if (i === l || i.nodeType === 8 && i.parentNode === l) break;
      if (o === 4) for (o = r.return; o !== null; ) {
        var s = o.tag;
        if ((s === 3 || s === 4) && (s = o.stateNode.containerInfo, s === l || s.nodeType === 8 && s.parentNode === l)) return;
        o = o.return;
      }
      for (; i !== null; ) {
        if (o = Ct(i), o === null) return;
        if (s = o.tag, s === 5 || s === 6) {
          r = u = o;
          continue e;
        }
        i = i.parentNode;
      }
    }
    r = r.return;
  }
  ws(function() {
    var c = u, h = Gu(n), m = [];
    e: {
      var p = Xs.get(e);
      if (p !== void 0) {
        var g = to, k = e;
        switch (e) {
          case "keypress":
            if (Nr(n) === 0) break e;
          case "keydown":
          case "keyup":
            g = vf;
            break;
          case "focusin":
            k = "focus", g = Tl;
            break;
          case "focusout":
            k = "blur", g = Tl;
            break;
          case "beforeblur":
          case "afterblur":
            g = Tl;
            break;
          case "click":
            if (n.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            g = Zo;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            g = rf;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            g = wf;
            break;
          case Ws:
          case Qs:
          case Ks:
            g = of;
            break;
          case Ys:
            g = Sf;
            break;
          case "scroll":
            g = tf;
            break;
          case "wheel":
            g = Ef;
            break;
          case "copy":
          case "cut":
          case "paste":
            g = af;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            g = qo;
        }
        var w = (t & 4) !== 0, M = !w && e === "scroll", f = w ? p !== null ? p + "Capture" : null : p;
        w = [];
        for (var a = c, d; a !== null; ) {
          d = a;
          var v = d.stateNode;
          if (d.tag === 5 && v !== null && (d = v, f !== null && (v = In(a, f), v != null && w.push(Hn(a, v, d)))), M) break;
          a = a.return;
        }
        0 < w.length && (p = new g(p, k, null, n, h), m.push({ event: p, listeners: w }));
      }
    }
    if (!(t & 7)) {
      e: {
        if (p = e === "mouseover" || e === "pointerover", g = e === "mouseout" || e === "pointerout", p && n !== uu && (k = n.relatedTarget || n.fromElement) && (Ct(k) || k[Ze])) break e;
        if ((g || p) && (p = h.window === h ? h : (p = h.ownerDocument) ? p.defaultView || p.parentWindow : window, g ? (k = n.relatedTarget || n.toElement, g = c, k = k ? Ct(k) : null, k !== null && (M = Dt(k), k !== M || k.tag !== 5 && k.tag !== 6) && (k = null)) : (g = null, k = c), g !== k)) {
          if (w = Zo, v = "onMouseLeave", f = "onMouseEnter", a = "mouse", (e === "pointerout" || e === "pointerover") && (w = qo, v = "onPointerLeave", f = "onPointerEnter", a = "pointer"), M = g == null ? p : Ht(g), d = k == null ? p : Ht(k), p = new w(v, a + "leave", g, n, h), p.target = M, p.relatedTarget = d, v = null, Ct(h) === c && (w = new w(f, a + "enter", k, n, h), w.target = d, w.relatedTarget = M, v = w), M = v, g && k) t: {
            for (w = g, f = k, a = 0, d = w; d; d = Ft(d)) a++;
            for (d = 0, v = f; v; v = Ft(v)) d++;
            for (; 0 < a - d; ) w = Ft(w), a--;
            for (; 0 < d - a; ) f = Ft(f), d--;
            for (; a--; ) {
              if (w === f || f !== null && w === f.alternate) break t;
              w = Ft(w), f = Ft(f);
            }
            w = null;
          }
          else w = null;
          g !== null && ai(m, p, g, w, !1), k !== null && M !== null && ai(m, M, k, w, !0);
        }
      }
      e: {
        if (p = c ? Ht(c) : window, g = p.nodeName && p.nodeName.toLowerCase(), g === "select" || g === "input" && p.type === "file") var x = Lf;
        else if (ti(p)) if ($s) x = Mf;
        else {
          x = Of;
          var C = Rf;
        }
        else (g = p.nodeName) && g.toLowerCase() === "input" && (p.type === "checkbox" || p.type === "radio") && (x = jf);
        if (x && (x = x(e, c))) {
          Us(m, x, n, h);
          break e;
        }
        C && C(e, p, c), e === "focusout" && (C = p._wrapperState) && C.controlled && p.type === "number" && eu(p, "number", p.value);
      }
      switch (C = c ? Ht(c) : window, e) {
        case "focusin":
          (ti(C) || C.contentEditable === "true") && (Vt = C, du = c, Tn = null);
          break;
        case "focusout":
          Tn = du = Vt = null;
          break;
        case "mousedown":
          pu = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          pu = !1, oi(m, n, h);
          break;
        case "selectionchange":
          if (Ff) break;
        case "keydown":
        case "keyup":
          oi(m, n, h);
      }
      var _;
      if (ro) e: {
        switch (e) {
          case "compositionstart":
            var N = "onCompositionStart";
            break e;
          case "compositionend":
            N = "onCompositionEnd";
            break e;
          case "compositionupdate":
            N = "onCompositionUpdate";
            break e;
        }
        N = void 0;
      }
      else At ? Is(e, n) && (N = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (N = "onCompositionStart");
      N && (Ds && n.locale !== "ko" && (At || N !== "onCompositionStart" ? N === "onCompositionEnd" && At && (_ = Ms()) : (ut = h, eo = "value" in ut ? ut.value : ut.textContent, At = !0)), C = Vr(c, N), 0 < C.length && (N = new Jo(N, e, null, n, h), m.push({ event: N, listeners: C }), _ ? N.data = _ : (_ = Fs(n), _ !== null && (N.data = _)))), (_ = _f ? Nf(e, n) : Pf(e, n)) && (c = Vr(c, "onBeforeInput"), 0 < c.length && (h = new Jo("onBeforeInput", "beforeinput", null, n, h), m.push({ event: h, listeners: c }), h.data = _));
    }
    Gs(m, t);
  });
}
function Hn(e, t, n) {
  return { instance: e, listener: t, currentTarget: n };
}
function Vr(e, t) {
  for (var n = t + "Capture", r = []; e !== null; ) {
    var l = e, u = l.stateNode;
    l.tag === 5 && u !== null && (l = u, u = In(e, n), u != null && r.unshift(Hn(e, u, l)), u = In(e, t), u != null && r.push(Hn(e, u, l))), e = e.return;
  }
  return r;
}
function Ft(e) {
  if (e === null) return null;
  do
    e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function ai(e, t, n, r, l) {
  for (var u = t._reactName, o = []; n !== null && n !== r; ) {
    var i = n, s = i.alternate, c = i.stateNode;
    if (s !== null && s === r) break;
    i.tag === 5 && c !== null && (i = c, l ? (s = In(n, u), s != null && o.unshift(Hn(n, s, i))) : l || (s = In(n, u), s != null && o.push(Hn(n, s, i)))), n = n.return;
  }
  o.length !== 0 && e.push({ event: t, listeners: o });
}
var Vf = /\r\n?/g, Bf = /\u0000|\uFFFD/g;
function ci(e) {
  return (typeof e == "string" ? e : "" + e).replace(Vf, `
`).replace(Bf, "");
}
function hr(e, t, n) {
  if (t = ci(t), ci(e) !== t && n) throw Error(y(425));
}
function Br() {
}
var mu = null, hu = null;
function vu(e, t) {
  return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
}
var yu = typeof setTimeout == "function" ? setTimeout : void 0, Hf = typeof clearTimeout == "function" ? clearTimeout : void 0, fi = typeof Promise == "function" ? Promise : void 0, Wf = typeof queueMicrotask == "function" ? queueMicrotask : typeof fi != "undefined" ? function(e) {
  return fi.resolve(null).then(e).catch(Qf);
} : yu;
function Qf(e) {
  setTimeout(function() {
    throw e;
  });
}
function Fl(e, t) {
  var n = t, r = 0;
  do {
    var l = n.nextSibling;
    if (e.removeChild(n), l && l.nodeType === 8) if (n = l.data, n === "/$") {
      if (r === 0) {
        e.removeChild(l), $n(t);
        return;
      }
      r--;
    } else n !== "$" && n !== "$?" && n !== "$!" || r++;
    n = l;
  } while (n);
  $n(t);
}
function ct(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (t = e.data, t === "$" || t === "$!" || t === "$?") break;
      if (t === "/$") return null;
    }
  }
  return e;
}
function di(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === "$" || n === "$!" || n === "$?") {
        if (t === 0) return e;
        t--;
      } else n === "/$" && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var dn = Math.random().toString(36).slice(2), Ve = "__reactFiber$" + dn, Wn = "__reactProps$" + dn, Ze = "__reactContainer$" + dn, gu = "__reactEvents$" + dn, Kf = "__reactListeners$" + dn, Yf = "__reactHandles$" + dn;
function Ct(e) {
  var t = e[Ve];
  if (t) return t;
  for (var n = e.parentNode; n; ) {
    if (t = n[Ze] || n[Ve]) {
      if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = di(e); e !== null; ) {
        if (n = e[Ve]) return n;
        e = di(e);
      }
      return t;
    }
    e = n, n = e.parentNode;
  }
  return null;
}
function er(e) {
  return e = e[Ve] || e[Ze], !e || e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3 ? null : e;
}
function Ht(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(y(33));
}
function al(e) {
  return e[Wn] || null;
}
var wu = [], Wt = -1;
function gt(e) {
  return { current: e };
}
function $(e) {
  0 > Wt || (e.current = wu[Wt], wu[Wt] = null, Wt--);
}
function F(e, t) {
  Wt++, wu[Wt] = e.current, e.current = t;
}
var vt = {}, ie = gt(vt), he = gt(!1), Tt = vt;
function rn(e, t) {
  var n = e.type.contextTypes;
  if (!n) return vt;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
  var l = {}, u;
  for (u in n) l[u] = t[u];
  return r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = l), l;
}
function ve(e) {
  return e = e.childContextTypes, e != null;
}
function Hr() {
  $(he), $(ie);
}
function pi(e, t, n) {
  if (ie.current !== vt) throw Error(y(168));
  F(ie, t), F(he, n);
}
function Js(e, t, n) {
  var r = e.stateNode;
  if (t = t.childContextTypes, typeof r.getChildContext != "function") return n;
  r = r.getChildContext();
  for (var l in r) if (!(l in t)) throw Error(y(108, Lc(e) || "Unknown", l));
  return W({}, n, r);
}
function Wr(e) {
  return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || vt, Tt = ie.current, F(ie, e), F(he, he.current), !0;
}
function mi(e, t, n) {
  var r = e.stateNode;
  if (!r) throw Error(y(169));
  n ? (e = Js(e, t, Tt), r.__reactInternalMemoizedMergedChildContext = e, $(he), $(ie), F(ie, e)) : $(he), F(he, n);
}
var Qe = null, cl = !1, Ul = !1;
function qs(e) {
  Qe === null ? Qe = [e] : Qe.push(e);
}
function Xf(e) {
  cl = !0, qs(e);
}
function wt() {
  if (!Ul && Qe !== null) {
    Ul = !0;
    var e = 0, t = j;
    try {
      var n = Qe;
      for (j = 1; e < n.length; e++) {
        var r = n[e];
        do
          r = r(!0);
        while (r !== null);
      }
      Qe = null, cl = !1;
    } catch (l) {
      throw Qe !== null && (Qe = Qe.slice(e + 1)), Es(Zu, wt), l;
    } finally {
      j = t, Ul = !1;
    }
  }
  return null;
}
var Qt = [], Kt = 0, Qr = null, Kr = 0, _e = [], Ne = 0, Lt = null, Ke = 1, Ye = "";
function xt(e, t) {
  Qt[Kt++] = Kr, Qt[Kt++] = Qr, Qr = e, Kr = t;
}
function bs(e, t, n) {
  _e[Ne++] = Ke, _e[Ne++] = Ye, _e[Ne++] = Lt, Lt = e;
  var r = Ke;
  e = Ye;
  var l = 32 - Ie(r) - 1;
  r &= ~(1 << l), n += 1;
  var u = 32 - Ie(t) + l;
  if (30 < u) {
    var o = l - l % 5;
    u = (r & (1 << o) - 1).toString(32), r >>= o, l -= o, Ke = 1 << 32 - Ie(t) + l | n << l | r, Ye = u + e;
  } else Ke = 1 << u | n << l | r, Ye = e;
}
function uo(e) {
  e.return !== null && (xt(e, 1), bs(e, 1, 0));
}
function oo(e) {
  for (; e === Qr; ) Qr = Qt[--Kt], Qt[Kt] = null, Kr = Qt[--Kt], Qt[Kt] = null;
  for (; e === Lt; ) Lt = _e[--Ne], _e[Ne] = null, Ye = _e[--Ne], _e[Ne] = null, Ke = _e[--Ne], _e[Ne] = null;
}
var ke = null, we = null, A = !1, De = null;
function ea(e, t) {
  var n = Pe(5, null, null, 0);
  n.elementType = "DELETED", n.stateNode = t, n.return = e, t = e.deletions, t === null ? (e.deletions = [n], e.flags |= 16) : t.push(n);
}
function hi(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t, t !== null ? (e.stateNode = t, ke = e, we = ct(t.firstChild), !0) : !1;
    case 6:
      return t = e.pendingProps === "" || t.nodeType !== 3 ? null : t, t !== null ? (e.stateNode = t, ke = e, we = null, !0) : !1;
    case 13:
      return t = t.nodeType !== 8 ? null : t, t !== null ? (n = Lt !== null ? { id: Ke, overflow: Ye } : null, e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }, n = Pe(18, null, null, 0), n.stateNode = t, n.return = e, e.child = n, ke = e, we = null, !0) : !1;
    default:
      return !1;
  }
}
function ku(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function Su(e) {
  if (A) {
    var t = we;
    if (t) {
      var n = t;
      if (!hi(e, t)) {
        if (ku(e)) throw Error(y(418));
        t = ct(n.nextSibling);
        var r = ke;
        t && hi(e, t) ? ea(r, n) : (e.flags = e.flags & -4097 | 2, A = !1, ke = e);
      }
    } else {
      if (ku(e)) throw Error(y(418));
      e.flags = e.flags & -4097 | 2, A = !1, ke = e;
    }
  }
}
function vi(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
  ke = e;
}
function vr(e) {
  if (e !== ke) return !1;
  if (!A) return vi(e), A = !0, !1;
  var t;
  if ((t = e.tag !== 3) && !(t = e.tag !== 5) && (t = e.type, t = t !== "head" && t !== "body" && !vu(e.type, e.memoizedProps)), t && (t = we)) {
    if (ku(e)) throw ta(), Error(y(418));
    for (; t; ) ea(e, t), t = ct(t.nextSibling);
  }
  if (vi(e), e.tag === 13) {
    if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(y(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === "/$") {
            if (t === 0) {
              we = ct(e.nextSibling);
              break e;
            }
            t--;
          } else n !== "$" && n !== "$!" && n !== "$?" || t++;
        }
        e = e.nextSibling;
      }
      we = null;
    }
  } else we = ke ? ct(e.stateNode.nextSibling) : null;
  return !0;
}
function ta() {
  for (var e = we; e; ) e = ct(e.nextSibling);
}
function ln() {
  we = ke = null, A = !1;
}
function io(e) {
  De === null ? De = [e] : De.push(e);
}
var Gf = be.ReactCurrentBatchConfig;
function gn(e, t, n) {
  if (e = n.ref, e !== null && typeof e != "function" && typeof e != "object") {
    if (n._owner) {
      if (n = n._owner, n) {
        if (n.tag !== 1) throw Error(y(309));
        var r = n.stateNode;
      }
      if (!r) throw Error(y(147, e));
      var l = r, u = "" + e;
      return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === u ? t.ref : (t = function(o) {
        var i = l.refs;
        o === null ? delete i[u] : i[u] = o;
      }, t._stringRef = u, t);
    }
    if (typeof e != "string") throw Error(y(284));
    if (!n._owner) throw Error(y(290, e));
  }
  return e;
}
function yr(e, t) {
  throw e = Object.prototype.toString.call(t), Error(y(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e));
}
function yi(e) {
  var t = e._init;
  return t(e._payload);
}
function na(e) {
  function t(f, a) {
    if (e) {
      var d = f.deletions;
      d === null ? (f.deletions = [a], f.flags |= 16) : d.push(a);
    }
  }
  function n(f, a) {
    if (!e) return null;
    for (; a !== null; ) t(f, a), a = a.sibling;
    return null;
  }
  function r(f, a) {
    for (f = /* @__PURE__ */ new Map(); a !== null; ) a.key !== null ? f.set(a.key, a) : f.set(a.index, a), a = a.sibling;
    return f;
  }
  function l(f, a) {
    return f = mt(f, a), f.index = 0, f.sibling = null, f;
  }
  function u(f, a, d) {
    return f.index = d, e ? (d = f.alternate, d !== null ? (d = d.index, d < a ? (f.flags |= 2, a) : d) : (f.flags |= 2, a)) : (f.flags |= 1048576, a);
  }
  function o(f) {
    return e && f.alternate === null && (f.flags |= 2), f;
  }
  function i(f, a, d, v) {
    return a === null || a.tag !== 6 ? (a = Ql(d, f.mode, v), a.return = f, a) : (a = l(a, d), a.return = f, a);
  }
  function s(f, a, d, v) {
    var x = d.type;
    return x === $t ? h(f, a, d.props.children, v, d.key) : a !== null && (a.elementType === x || typeof x == "object" && x !== null && x.$$typeof === tt && yi(x) === a.type) ? (v = l(a, d.props), v.ref = gn(f, a, d), v.return = f, v) : (v = jr(d.type, d.key, d.props, null, f.mode, v), v.ref = gn(f, a, d), v.return = f, v);
  }
  function c(f, a, d, v) {
    return a === null || a.tag !== 4 || a.stateNode.containerInfo !== d.containerInfo || a.stateNode.implementation !== d.implementation ? (a = Kl(d, f.mode, v), a.return = f, a) : (a = l(a, d.children || []), a.return = f, a);
  }
  function h(f, a, d, v, x) {
    return a === null || a.tag !== 7 ? (a = zt(d, f.mode, v, x), a.return = f, a) : (a = l(a, d), a.return = f, a);
  }
  function m(f, a, d) {
    if (typeof a == "string" && a !== "" || typeof a == "number") return a = Ql("" + a, f.mode, d), a.return = f, a;
    if (typeof a == "object" && a !== null) {
      switch (a.$$typeof) {
        case or:
          return d = jr(a.type, a.key, a.props, null, f.mode, d), d.ref = gn(f, null, a), d.return = f, d;
        case Ut:
          return a = Kl(a, f.mode, d), a.return = f, a;
        case tt:
          var v = a._init;
          return m(f, v(a._payload), d);
      }
      if (xn(a) || pn(a)) return a = zt(a, f.mode, d, null), a.return = f, a;
      yr(f, a);
    }
    return null;
  }
  function p(f, a, d, v) {
    var x = a !== null ? a.key : null;
    if (typeof d == "string" && d !== "" || typeof d == "number") return x !== null ? null : i(f, a, "" + d, v);
    if (typeof d == "object" && d !== null) {
      switch (d.$$typeof) {
        case or:
          return d.key === x ? s(f, a, d, v) : null;
        case Ut:
          return d.key === x ? c(f, a, d, v) : null;
        case tt:
          return x = d._init, p(
            f,
            a,
            x(d._payload),
            v
          );
      }
      if (xn(d) || pn(d)) return x !== null ? null : h(f, a, d, v, null);
      yr(f, d);
    }
    return null;
  }
  function g(f, a, d, v, x) {
    if (typeof v == "string" && v !== "" || typeof v == "number") return f = f.get(d) || null, i(a, f, "" + v, x);
    if (typeof v == "object" && v !== null) {
      switch (v.$$typeof) {
        case or:
          return f = f.get(v.key === null ? d : v.key) || null, s(a, f, v, x);
        case Ut:
          return f = f.get(v.key === null ? d : v.key) || null, c(a, f, v, x);
        case tt:
          var C = v._init;
          return g(f, a, d, C(v._payload), x);
      }
      if (xn(v) || pn(v)) return f = f.get(d) || null, h(a, f, v, x, null);
      yr(a, v);
    }
    return null;
  }
  function k(f, a, d, v) {
    for (var x = null, C = null, _ = a, N = a = 0, V = null; _ !== null && N < d.length; N++) {
      _.index > N ? (V = _, _ = null) : V = _.sibling;
      var T = p(f, _, d[N], v);
      if (T === null) {
        _ === null && (_ = V);
        break;
      }
      e && _ && T.alternate === null && t(f, _), a = u(T, a, N), C === null ? x = T : C.sibling = T, C = T, _ = V;
    }
    if (N === d.length) return n(f, _), A && xt(f, N), x;
    if (_ === null) {
      for (; N < d.length; N++) _ = m(f, d[N], v), _ !== null && (a = u(_, a, N), C === null ? x = _ : C.sibling = _, C = _);
      return A && xt(f, N), x;
    }
    for (_ = r(f, _); N < d.length; N++) V = g(_, f, N, d[N], v), V !== null && (e && V.alternate !== null && _.delete(V.key === null ? N : V.key), a = u(V, a, N), C === null ? x = V : C.sibling = V, C = V);
    return e && _.forEach(function(I) {
      return t(f, I);
    }), A && xt(f, N), x;
  }
  function w(f, a, d, v) {
    var x = pn(d);
    if (typeof x != "function") throw Error(y(150));
    if (d = x.call(d), d == null) throw Error(y(151));
    for (var C = x = null, _ = a, N = a = 0, V = null, T = d.next(); _ !== null && !T.done; N++, T = d.next()) {
      _.index > N ? (V = _, _ = null) : V = _.sibling;
      var I = p(f, _, T.value, v);
      if (I === null) {
        _ === null && (_ = V);
        break;
      }
      e && _ && I.alternate === null && t(f, _), a = u(I, a, N), C === null ? x = I : C.sibling = I, C = I, _ = V;
    }
    if (T.done) return n(
      f,
      _
    ), A && xt(f, N), x;
    if (_ === null) {
      for (; !T.done; N++, T = d.next()) T = m(f, T.value, v), T !== null && (a = u(T, a, N), C === null ? x = T : C.sibling = T, C = T);
      return A && xt(f, N), x;
    }
    for (_ = r(f, _); !T.done; N++, T = d.next()) T = g(_, f, N, T.value, v), T !== null && (e && T.alternate !== null && _.delete(T.key === null ? N : T.key), a = u(T, a, N), C === null ? x = T : C.sibling = T, C = T);
    return e && _.forEach(function(Y) {
      return t(f, Y);
    }), A && xt(f, N), x;
  }
  function M(f, a, d, v) {
    if (typeof d == "object" && d !== null && d.type === $t && d.key === null && (d = d.props.children), typeof d == "object" && d !== null) {
      switch (d.$$typeof) {
        case or:
          e: {
            for (var x = d.key, C = a; C !== null; ) {
              if (C.key === x) {
                if (x = d.type, x === $t) {
                  if (C.tag === 7) {
                    n(f, C.sibling), a = l(C, d.props.children), a.return = f, f = a;
                    break e;
                  }
                } else if (C.elementType === x || typeof x == "object" && x !== null && x.$$typeof === tt && yi(x) === C.type) {
                  n(f, C.sibling), a = l(C, d.props), a.ref = gn(f, C, d), a.return = f, f = a;
                  break e;
                }
                n(f, C);
                break;
              } else t(f, C);
              C = C.sibling;
            }
            d.type === $t ? (a = zt(d.props.children, f.mode, v, d.key), a.return = f, f = a) : (v = jr(d.type, d.key, d.props, null, f.mode, v), v.ref = gn(f, a, d), v.return = f, f = v);
          }
          return o(f);
        case Ut:
          e: {
            for (C = d.key; a !== null; ) {
              if (a.key === C) if (a.tag === 4 && a.stateNode.containerInfo === d.containerInfo && a.stateNode.implementation === d.implementation) {
                n(f, a.sibling), a = l(a, d.children || []), a.return = f, f = a;
                break e;
              } else {
                n(f, a);
                break;
              }
              else t(f, a);
              a = a.sibling;
            }
            a = Kl(d, f.mode, v), a.return = f, f = a;
          }
          return o(f);
        case tt:
          return C = d._init, M(f, a, C(d._payload), v);
      }
      if (xn(d)) return k(f, a, d, v);
      if (pn(d)) return w(f, a, d, v);
      yr(f, d);
    }
    return typeof d == "string" && d !== "" || typeof d == "number" ? (d = "" + d, a !== null && a.tag === 6 ? (n(f, a.sibling), a = l(a, d), a.return = f, f = a) : (n(f, a), a = Ql(d, f.mode, v), a.return = f, f = a), o(f)) : n(f, a);
  }
  return M;
}
var un = na(!0), ra = na(!1), Yr = gt(null), Xr = null, Yt = null, so = null;
function ao() {
  so = Yt = Xr = null;
}
function co(e) {
  var t = Yr.current;
  $(Yr), e._currentValue = t;
}
function xu(e, t, n) {
  for (; e !== null; ) {
    var r = e.alternate;
    if ((e.childLanes & t) !== t ? (e.childLanes |= t, r !== null && (r.childLanes |= t)) : r !== null && (r.childLanes & t) !== t && (r.childLanes |= t), e === n) break;
    e = e.return;
  }
}
function en(e, t) {
  Xr = e, so = Yt = null, e = e.dependencies, e !== null && e.firstContext !== null && (e.lanes & t && (me = !0), e.firstContext = null);
}
function Te(e) {
  var t = e._currentValue;
  if (so !== e) if (e = { context: e, memoizedValue: t, next: null }, Yt === null) {
    if (Xr === null) throw Error(y(308));
    Yt = e, Xr.dependencies = { lanes: 0, firstContext: e };
  } else Yt = Yt.next = e;
  return t;
}
var _t = null;
function fo(e) {
  _t === null ? _t = [e] : _t.push(e);
}
function la(e, t, n, r) {
  var l = t.interleaved;
  return l === null ? (n.next = n, fo(t)) : (n.next = l.next, l.next = n), t.interleaved = n, Je(e, r);
}
function Je(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; ) e.childLanes |= t, n = e.alternate, n !== null && (n.childLanes |= t), n = e, e = e.return;
  return n.tag === 3 ? n.stateNode : null;
}
var nt = !1;
function po(e) {
  e.updateQueue = { baseState: e.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
}
function ua(e, t) {
  e = e.updateQueue, t.updateQueue === e && (t.updateQueue = { baseState: e.baseState, firstBaseUpdate: e.firstBaseUpdate, lastBaseUpdate: e.lastBaseUpdate, shared: e.shared, effects: e.effects });
}
function Xe(e, t) {
  return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
}
function ft(e, t, n) {
  var r = e.updateQueue;
  if (r === null) return null;
  if (r = r.shared, R & 2) {
    var l = r.pending;
    return l === null ? t.next = t : (t.next = l.next, l.next = t), r.pending = t, Je(e, n);
  }
  return l = r.interleaved, l === null ? (t.next = t, fo(r)) : (t.next = l.next, l.next = t), r.interleaved = t, Je(e, n);
}
function Pr(e, t, n) {
  if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194240) !== 0)) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, Ju(e, n);
  }
}
function gi(e, t) {
  var n = e.updateQueue, r = e.alternate;
  if (r !== null && (r = r.updateQueue, n === r)) {
    var l = null, u = null;
    if (n = n.firstBaseUpdate, n !== null) {
      do {
        var o = { eventTime: n.eventTime, lane: n.lane, tag: n.tag, payload: n.payload, callback: n.callback, next: null };
        u === null ? l = u = o : u = u.next = o, n = n.next;
      } while (n !== null);
      u === null ? l = u = t : u = u.next = t;
    } else l = u = t;
    n = { baseState: r.baseState, firstBaseUpdate: l, lastBaseUpdate: u, shared: r.shared, effects: r.effects }, e.updateQueue = n;
    return;
  }
  e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
}
function Gr(e, t, n, r) {
  var l = e.updateQueue;
  nt = !1;
  var u = l.firstBaseUpdate, o = l.lastBaseUpdate, i = l.shared.pending;
  if (i !== null) {
    l.shared.pending = null;
    var s = i, c = s.next;
    s.next = null, o === null ? u = c : o.next = c, o = s;
    var h = e.alternate;
    h !== null && (h = h.updateQueue, i = h.lastBaseUpdate, i !== o && (i === null ? h.firstBaseUpdate = c : i.next = c, h.lastBaseUpdate = s));
  }
  if (u !== null) {
    var m = l.baseState;
    o = 0, h = c = s = null, i = u;
    do {
      var p = i.lane, g = i.eventTime;
      if ((r & p) === p) {
        h !== null && (h = h.next = {
          eventTime: g,
          lane: 0,
          tag: i.tag,
          payload: i.payload,
          callback: i.callback,
          next: null
        });
        e: {
          var k = e, w = i;
          switch (p = t, g = n, w.tag) {
            case 1:
              if (k = w.payload, typeof k == "function") {
                m = k.call(g, m, p);
                break e;
              }
              m = k;
              break e;
            case 3:
              k.flags = k.flags & -65537 | 128;
            case 0:
              if (k = w.payload, p = typeof k == "function" ? k.call(g, m, p) : k, p == null) break e;
              m = W({}, m, p);
              break e;
            case 2:
              nt = !0;
          }
        }
        i.callback !== null && i.lane !== 0 && (e.flags |= 64, p = l.effects, p === null ? l.effects = [i] : p.push(i));
      } else g = { eventTime: g, lane: p, tag: i.tag, payload: i.payload, callback: i.callback, next: null }, h === null ? (c = h = g, s = m) : h = h.next = g, o |= p;
      if (i = i.next, i === null) {
        if (i = l.shared.pending, i === null) break;
        p = i, i = p.next, p.next = null, l.lastBaseUpdate = p, l.shared.pending = null;
      }
    } while (!0);
    if (h === null && (s = m), l.baseState = s, l.firstBaseUpdate = c, l.lastBaseUpdate = h, t = l.shared.interleaved, t !== null) {
      l = t;
      do
        o |= l.lane, l = l.next;
      while (l !== t);
    } else u === null && (l.shared.lanes = 0);
    Ot |= o, e.lanes = o, e.memoizedState = m;
  }
}
function wi(e, t, n) {
  if (e = t.effects, t.effects = null, e !== null) for (t = 0; t < e.length; t++) {
    var r = e[t], l = r.callback;
    if (l !== null) {
      if (r.callback = null, r = n, typeof l != "function") throw Error(y(191, l));
      l.call(r);
    }
  }
}
var tr = {}, He = gt(tr), Qn = gt(tr), Kn = gt(tr);
function Nt(e) {
  if (e === tr) throw Error(y(174));
  return e;
}
function mo(e, t) {
  switch (F(Kn, t), F(Qn, e), F(He, tr), e = t.nodeType, e) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : nu(null, "");
      break;
    default:
      e = e === 8 ? t.parentNode : t, t = e.namespaceURI || null, e = e.tagName, t = nu(t, e);
  }
  $(He), F(He, t);
}
function on() {
  $(He), $(Qn), $(Kn);
}
function oa(e) {
  Nt(Kn.current);
  var t = Nt(He.current), n = nu(t, e.type);
  t !== n && (F(Qn, e), F(He, n));
}
function ho(e) {
  Qn.current === e && ($(He), $(Qn));
}
var B = gt(0);
function Zr(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (n !== null && (n = n.dehydrated, n === null || n.data === "$?" || n.data === "$!")) return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if (t.flags & 128) return t;
    } else if (t.child !== null) {
      t.child.return = t, t = t.child;
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    t.sibling.return = t.return, t = t.sibling;
  }
  return null;
}
var $l = [];
function vo() {
  for (var e = 0; e < $l.length; e++) $l[e]._workInProgressVersionPrimary = null;
  $l.length = 0;
}
var zr = be.ReactCurrentDispatcher, Al = be.ReactCurrentBatchConfig, Rt = 0, H = null, G = null, q = null, Jr = !1, Ln = !1, Yn = 0, Zf = 0;
function le() {
  throw Error(y(321));
}
function yo(e, t) {
  if (t === null) return !1;
  for (var n = 0; n < t.length && n < e.length; n++) if (!Ue(e[n], t[n])) return !1;
  return !0;
}
function go(e, t, n, r, l, u) {
  if (Rt = u, H = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, zr.current = e === null || e.memoizedState === null ? ed : td, e = n(r, l), Ln) {
    u = 0;
    do {
      if (Ln = !1, Yn = 0, 25 <= u) throw Error(y(301));
      u += 1, q = G = null, t.updateQueue = null, zr.current = nd, e = n(r, l);
    } while (Ln);
  }
  if (zr.current = qr, t = G !== null && G.next !== null, Rt = 0, q = G = H = null, Jr = !1, t) throw Error(y(300));
  return e;
}
function wo() {
  var e = Yn !== 0;
  return Yn = 0, e;
}
function Ae() {
  var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return q === null ? H.memoizedState = q = e : q = q.next = e, q;
}
function Le() {
  if (G === null) {
    var e = H.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = G.next;
  var t = q === null ? H.memoizedState : q.next;
  if (t !== null) q = t, G = e;
  else {
    if (e === null) throw Error(y(310));
    G = e, e = { memoizedState: G.memoizedState, baseState: G.baseState, baseQueue: G.baseQueue, queue: G.queue, next: null }, q === null ? H.memoizedState = q = e : q = q.next = e;
  }
  return q;
}
function Xn(e, t) {
  return typeof t == "function" ? t(e) : t;
}
function Vl(e) {
  var t = Le(), n = t.queue;
  if (n === null) throw Error(y(311));
  n.lastRenderedReducer = e;
  var r = G, l = r.baseQueue, u = n.pending;
  if (u !== null) {
    if (l !== null) {
      var o = l.next;
      l.next = u.next, u.next = o;
    }
    r.baseQueue = l = u, n.pending = null;
  }
  if (l !== null) {
    u = l.next, r = r.baseState;
    var i = o = null, s = null, c = u;
    do {
      var h = c.lane;
      if ((Rt & h) === h) s !== null && (s = s.next = { lane: 0, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null }), r = c.hasEagerState ? c.eagerState : e(r, c.action);
      else {
        var m = {
          lane: h,
          action: c.action,
          hasEagerState: c.hasEagerState,
          eagerState: c.eagerState,
          next: null
        };
        s === null ? (i = s = m, o = r) : s = s.next = m, H.lanes |= h, Ot |= h;
      }
      c = c.next;
    } while (c !== null && c !== u);
    s === null ? o = r : s.next = i, Ue(r, t.memoizedState) || (me = !0), t.memoizedState = r, t.baseState = o, t.baseQueue = s, n.lastRenderedState = r;
  }
  if (e = n.interleaved, e !== null) {
    l = e;
    do
      u = l.lane, H.lanes |= u, Ot |= u, l = l.next;
    while (l !== e);
  } else l === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function Bl(e) {
  var t = Le(), n = t.queue;
  if (n === null) throw Error(y(311));
  n.lastRenderedReducer = e;
  var r = n.dispatch, l = n.pending, u = t.memoizedState;
  if (l !== null) {
    n.pending = null;
    var o = l = l.next;
    do
      u = e(u, o.action), o = o.next;
    while (o !== l);
    Ue(u, t.memoizedState) || (me = !0), t.memoizedState = u, t.baseQueue === null && (t.baseState = u), n.lastRenderedState = u;
  }
  return [u, r];
}
function ia() {
}
function sa(e, t) {
  var n = H, r = Le(), l = t(), u = !Ue(r.memoizedState, l);
  if (u && (r.memoizedState = l, me = !0), r = r.queue, ko(fa.bind(null, n, r, e), [e]), r.getSnapshot !== t || u || q !== null && q.memoizedState.tag & 1) {
    if (n.flags |= 2048, Gn(9, ca.bind(null, n, r, l, t), void 0, null), b === null) throw Error(y(349));
    Rt & 30 || aa(n, t, l);
  }
  return l;
}
function aa(e, t, n) {
  e.flags |= 16384, e = { getSnapshot: t, value: n }, t = H.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, H.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
}
function ca(e, t, n, r) {
  t.value = n, t.getSnapshot = r, da(t) && pa(e);
}
function fa(e, t, n) {
  return n(function() {
    da(t) && pa(e);
  });
}
function da(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !Ue(e, n);
  } catch {
    return !0;
  }
}
function pa(e) {
  var t = Je(e, 1);
  t !== null && Fe(t, e, 1, -1);
}
function ki(e) {
  var t = Ae();
  return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Xn, lastRenderedState: e }, t.queue = e, e = e.dispatch = bf.bind(null, H, e), [t.memoizedState, e];
}
function Gn(e, t, n, r) {
  return e = { tag: e, create: t, destroy: n, deps: r, next: null }, t = H.updateQueue, t === null ? (t = { lastEffect: null, stores: null }, H.updateQueue = t, t.lastEffect = e.next = e) : (n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e)), e;
}
function ma() {
  return Le().memoizedState;
}
function Tr(e, t, n, r) {
  var l = Ae();
  H.flags |= e, l.memoizedState = Gn(1 | t, n, void 0, r === void 0 ? null : r);
}
function fl(e, t, n, r) {
  var l = Le();
  r = r === void 0 ? null : r;
  var u = void 0;
  if (G !== null) {
    var o = G.memoizedState;
    if (u = o.destroy, r !== null && yo(r, o.deps)) {
      l.memoizedState = Gn(t, n, u, r);
      return;
    }
  }
  H.flags |= e, l.memoizedState = Gn(1 | t, n, u, r);
}
function Si(e, t) {
  return Tr(8390656, 8, e, t);
}
function ko(e, t) {
  return fl(2048, 8, e, t);
}
function ha(e, t) {
  return fl(4, 2, e, t);
}
function va(e, t) {
  return fl(4, 4, e, t);
}
function ya(e, t) {
  if (typeof t == "function") return e = e(), t(e), function() {
    t(null);
  };
  if (t != null) return e = e(), t.current = e, function() {
    t.current = null;
  };
}
function ga(e, t, n) {
  return n = n != null ? n.concat([e]) : null, fl(4, 4, ya.bind(null, t, e), n);
}
function So() {
}
function wa(e, t) {
  var n = Le();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && yo(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
}
function ka(e, t) {
  var n = Le();
  t = t === void 0 ? null : t;
  var r = n.memoizedState;
  return r !== null && t !== null && yo(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
}
function Sa(e, t, n) {
  return Rt & 21 ? (Ue(n, t) || (n = Ns(), H.lanes |= n, Ot |= n, e.baseState = !0), t) : (e.baseState && (e.baseState = !1, me = !0), e.memoizedState = n);
}
function Jf(e, t) {
  var n = j;
  j = n !== 0 && 4 > n ? n : 4, e(!0);
  var r = Al.transition;
  Al.transition = {};
  try {
    e(!1), t();
  } finally {
    j = n, Al.transition = r;
  }
}
function xa() {
  return Le().memoizedState;
}
function qf(e, t, n) {
  var r = pt(e);
  if (n = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null }, Ea(e)) Ca(t, n);
  else if (n = la(e, t, n, r), n !== null) {
    var l = ce();
    Fe(n, e, r, l), _a(n, t, r);
  }
}
function bf(e, t, n) {
  var r = pt(e), l = { lane: r, action: n, hasEagerState: !1, eagerState: null, next: null };
  if (Ea(e)) Ca(t, l);
  else {
    var u = e.alternate;
    if (e.lanes === 0 && (u === null || u.lanes === 0) && (u = t.lastRenderedReducer, u !== null)) try {
      var o = t.lastRenderedState, i = u(o, n);
      if (l.hasEagerState = !0, l.eagerState = i, Ue(i, o)) {
        var s = t.interleaved;
        s === null ? (l.next = l, fo(t)) : (l.next = s.next, s.next = l), t.interleaved = l;
        return;
      }
    } catch {
    } finally {
    }
    n = la(e, t, l, r), n !== null && (l = ce(), Fe(n, e, r, l), _a(n, t, r));
  }
}
function Ea(e) {
  var t = e.alternate;
  return e === H || t !== null && t === H;
}
function Ca(e, t) {
  Ln = Jr = !0;
  var n = e.pending;
  n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
}
function _a(e, t, n) {
  if (n & 4194240) {
    var r = t.lanes;
    r &= e.pendingLanes, n |= r, t.lanes = n, Ju(e, n);
  }
}
var qr = { readContext: Te, useCallback: le, useContext: le, useEffect: le, useImperativeHandle: le, useInsertionEffect: le, useLayoutEffect: le, useMemo: le, useReducer: le, useRef: le, useState: le, useDebugValue: le, useDeferredValue: le, useTransition: le, useMutableSource: le, useSyncExternalStore: le, useId: le, unstable_isNewReconciler: !1 }, ed = { readContext: Te, useCallback: function(e, t) {
  return Ae().memoizedState = [e, t === void 0 ? null : t], e;
}, useContext: Te, useEffect: Si, useImperativeHandle: function(e, t, n) {
  return n = n != null ? n.concat([e]) : null, Tr(
    4194308,
    4,
    ya.bind(null, t, e),
    n
  );
}, useLayoutEffect: function(e, t) {
  return Tr(4194308, 4, e, t);
}, useInsertionEffect: function(e, t) {
  return Tr(4, 2, e, t);
}, useMemo: function(e, t) {
  var n = Ae();
  return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
}, useReducer: function(e, t, n) {
  var r = Ae();
  return t = n !== void 0 ? n(t) : t, r.memoizedState = r.baseState = t, e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: e, lastRenderedState: t }, r.queue = e, e = e.dispatch = qf.bind(null, H, e), [r.memoizedState, e];
}, useRef: function(e) {
  var t = Ae();
  return e = { current: e }, t.memoizedState = e;
}, useState: ki, useDebugValue: So, useDeferredValue: function(e) {
  return Ae().memoizedState = e;
}, useTransition: function() {
  var e = ki(!1), t = e[0];
  return e = Jf.bind(null, e[1]), Ae().memoizedState = e, [t, e];
}, useMutableSource: function() {
}, useSyncExternalStore: function(e, t, n) {
  var r = H, l = Ae();
  if (A) {
    if (n === void 0) throw Error(y(407));
    n = n();
  } else {
    if (n = t(), b === null) throw Error(y(349));
    Rt & 30 || aa(r, t, n);
  }
  l.memoizedState = n;
  var u = { value: n, getSnapshot: t };
  return l.queue = u, Si(fa.bind(
    null,
    r,
    u,
    e
  ), [e]), r.flags |= 2048, Gn(9, ca.bind(null, r, u, n, t), void 0, null), n;
}, useId: function() {
  var e = Ae(), t = b.identifierPrefix;
  if (A) {
    var n = Ye, r = Ke;
    n = (r & ~(1 << 32 - Ie(r) - 1)).toString(32) + n, t = ":" + t + "R" + n, n = Yn++, 0 < n && (t += "H" + n.toString(32)), t += ":";
  } else n = Zf++, t = ":" + t + "r" + n.toString(32) + ":";
  return e.memoizedState = t;
}, unstable_isNewReconciler: !1 }, td = {
  readContext: Te,
  useCallback: wa,
  useContext: Te,
  useEffect: ko,
  useImperativeHandle: ga,
  useInsertionEffect: ha,
  useLayoutEffect: va,
  useMemo: ka,
  useReducer: Vl,
  useRef: ma,
  useState: function() {
    return Vl(Xn);
  },
  useDebugValue: So,
  useDeferredValue: function(e) {
    var t = Le();
    return Sa(t, G.memoizedState, e);
  },
  useTransition: function() {
    var e = Vl(Xn)[0], t = Le().memoizedState;
    return [e, t];
  },
  useMutableSource: ia,
  useSyncExternalStore: sa,
  useId: xa,
  unstable_isNewReconciler: !1
}, nd = { readContext: Te, useCallback: wa, useContext: Te, useEffect: ko, useImperativeHandle: ga, useInsertionEffect: ha, useLayoutEffect: va, useMemo: ka, useReducer: Bl, useRef: ma, useState: function() {
  return Bl(Xn);
}, useDebugValue: So, useDeferredValue: function(e) {
  var t = Le();
  return G === null ? t.memoizedState = e : Sa(t, G.memoizedState, e);
}, useTransition: function() {
  var e = Bl(Xn)[0], t = Le().memoizedState;
  return [e, t];
}, useMutableSource: ia, useSyncExternalStore: sa, useId: xa, unstable_isNewReconciler: !1 };
function je(e, t) {
  if (e && e.defaultProps) {
    t = W({}, t), e = e.defaultProps;
    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
function Eu(e, t, n, r) {
  t = e.memoizedState, n = n(r, t), n = n == null ? t : W({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
}
var dl = { isMounted: function(e) {
  return (e = e._reactInternals) ? Dt(e) === e : !1;
}, enqueueSetState: function(e, t, n) {
  e = e._reactInternals;
  var r = ce(), l = pt(e), u = Xe(r, l);
  u.payload = t, n != null && (u.callback = n), t = ft(e, u, l), t !== null && (Fe(t, e, l, r), Pr(t, e, l));
}, enqueueReplaceState: function(e, t, n) {
  e = e._reactInternals;
  var r = ce(), l = pt(e), u = Xe(r, l);
  u.tag = 1, u.payload = t, n != null && (u.callback = n), t = ft(e, u, l), t !== null && (Fe(t, e, l, r), Pr(t, e, l));
}, enqueueForceUpdate: function(e, t) {
  e = e._reactInternals;
  var n = ce(), r = pt(e), l = Xe(n, r);
  l.tag = 2, t != null && (l.callback = t), t = ft(e, l, r), t !== null && (Fe(t, e, r, n), Pr(t, e, r));
} };
function xi(e, t, n, r, l, u, o) {
  return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, u, o) : t.prototype && t.prototype.isPureReactComponent ? !Vn(n, r) || !Vn(l, u) : !0;
}
function Na(e, t, n) {
  var r = !1, l = vt, u = t.contextType;
  return typeof u == "object" && u !== null ? u = Te(u) : (l = ve(t) ? Tt : ie.current, r = t.contextTypes, u = (r = r != null) ? rn(e, l) : vt), t = new t(n, u), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = dl, e.stateNode = t, t._reactInternals = e, r && (e = e.stateNode, e.__reactInternalMemoizedUnmaskedChildContext = l, e.__reactInternalMemoizedMaskedChildContext = u), t;
}
function Ei(e, t, n, r) {
  e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && dl.enqueueReplaceState(t, t.state, null);
}
function Cu(e, t, n, r) {
  var l = e.stateNode;
  l.props = n, l.state = e.memoizedState, l.refs = {}, po(e);
  var u = t.contextType;
  typeof u == "object" && u !== null ? l.context = Te(u) : (u = ve(t) ? Tt : ie.current, l.context = rn(e, u)), l.state = e.memoizedState, u = t.getDerivedStateFromProps, typeof u == "function" && (Eu(e, t, u, n), l.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof l.getSnapshotBeforeUpdate == "function" || typeof l.UNSAFE_componentWillMount != "function" && typeof l.componentWillMount != "function" || (t = l.state, typeof l.componentWillMount == "function" && l.componentWillMount(), typeof l.UNSAFE_componentWillMount == "function" && l.UNSAFE_componentWillMount(), t !== l.state && dl.enqueueReplaceState(l, l.state, null), Gr(e, n, l, r), l.state = e.memoizedState), typeof l.componentDidMount == "function" && (e.flags |= 4194308);
}
function sn(e, t) {
  try {
    var n = "", r = t;
    do
      n += Tc(r), r = r.return;
    while (r);
    var l = n;
  } catch (u) {
    l = `
Error generating stack: ` + u.message + `
` + u.stack;
  }
  return { value: e, source: t, stack: l, digest: null };
}
function Hl(e, t, n) {
  return { value: e, source: null, stack: n != null ? n : null, digest: t != null ? t : null };
}
function _u(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function() {
      throw n;
    });
  }
}
var rd = typeof WeakMap == "function" ? WeakMap : Map;
function Pa(e, t, n) {
  n = Xe(-1, n), n.tag = 3, n.payload = { element: null };
  var r = t.value;
  return n.callback = function() {
    el || (el = !0, Du = r), _u(e, t);
  }, n;
}
function za(e, t, n) {
  n = Xe(-1, n), n.tag = 3;
  var r = e.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var l = t.value;
    n.payload = function() {
      return r(l);
    }, n.callback = function() {
      _u(e, t);
    };
  }
  var u = e.stateNode;
  return u !== null && typeof u.componentDidCatch == "function" && (n.callback = function() {
    _u(e, t), typeof r != "function" && (dt === null ? dt = /* @__PURE__ */ new Set([this]) : dt.add(this));
    var o = t.stack;
    this.componentDidCatch(t.value, { componentStack: o !== null ? o : "" });
  }), n;
}
function Ci(e, t, n) {
  var r = e.pingCache;
  if (r === null) {
    r = e.pingCache = new rd();
    var l = /* @__PURE__ */ new Set();
    r.set(t, l);
  } else l = r.get(t), l === void 0 && (l = /* @__PURE__ */ new Set(), r.set(t, l));
  l.has(n) || (l.add(n), e = yd.bind(null, e, t, n), t.then(e, e));
}
function _i(e) {
  do {
    var t;
    if ((t = e.tag === 13) && (t = e.memoizedState, t = t !== null ? t.dehydrated !== null : !0), t) return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function Ni(e, t, n, r, l) {
  return e.mode & 1 ? (e.flags |= 65536, e.lanes = l, e) : (e === t ? e.flags |= 65536 : (e.flags |= 128, n.flags |= 131072, n.flags &= -52805, n.tag === 1 && (n.alternate === null ? n.tag = 17 : (t = Xe(-1, 1), t.tag = 2, ft(n, t, 1))), n.lanes |= 1), e);
}
var ld = be.ReactCurrentOwner, me = !1;
function ae(e, t, n, r) {
  t.child = e === null ? ra(t, null, n, r) : un(t, e.child, n, r);
}
function Pi(e, t, n, r, l) {
  n = n.render;
  var u = t.ref;
  return en(t, l), r = go(e, t, n, r, u, l), n = wo(), e !== null && !me ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~l, qe(e, t, l)) : (A && n && uo(t), t.flags |= 1, ae(e, t, r, l), t.child);
}
function zi(e, t, n, r, l) {
  if (e === null) {
    var u = n.type;
    return typeof u == "function" && !To(u) && u.defaultProps === void 0 && n.compare === null && n.defaultProps === void 0 ? (t.tag = 15, t.type = u, Ta(e, t, u, r, l)) : (e = jr(n.type, null, r, t, t.mode, l), e.ref = t.ref, e.return = t, t.child = e);
  }
  if (u = e.child, !(e.lanes & l)) {
    var o = u.memoizedProps;
    if (n = n.compare, n = n !== null ? n : Vn, n(o, r) && e.ref === t.ref) return qe(e, t, l);
  }
  return t.flags |= 1, e = mt(u, r), e.ref = t.ref, e.return = t, t.child = e;
}
function Ta(e, t, n, r, l) {
  if (e !== null) {
    var u = e.memoizedProps;
    if (Vn(u, r) && e.ref === t.ref) if (me = !1, t.pendingProps = r = u, (e.lanes & l) !== 0) e.flags & 131072 && (me = !0);
    else return t.lanes = e.lanes, qe(e, t, l);
  }
  return Nu(e, t, n, r, l);
}
function La(e, t, n) {
  var r = t.pendingProps, l = r.children, u = e !== null ? e.memoizedState : null;
  if (r.mode === "hidden") if (!(t.mode & 1)) t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, F(Gt, ge), ge |= n;
  else {
    if (!(n & 1073741824)) return e = u !== null ? u.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }, t.updateQueue = null, F(Gt, ge), ge |= e, null;
    t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, r = u !== null ? u.baseLanes : n, F(Gt, ge), ge |= r;
  }
  else u !== null ? (r = u.baseLanes | n, t.memoizedState = null) : r = n, F(Gt, ge), ge |= r;
  return ae(e, t, l, n), t.child;
}
function Ra(e, t) {
  var n = t.ref;
  (e === null && n !== null || e !== null && e.ref !== n) && (t.flags |= 512, t.flags |= 2097152);
}
function Nu(e, t, n, r, l) {
  var u = ve(n) ? Tt : ie.current;
  return u = rn(t, u), en(t, l), n = go(e, t, n, r, u, l), r = wo(), e !== null && !me ? (t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~l, qe(e, t, l)) : (A && r && uo(t), t.flags |= 1, ae(e, t, n, l), t.child);
}
function Ti(e, t, n, r, l) {
  if (ve(n)) {
    var u = !0;
    Wr(t);
  } else u = !1;
  if (en(t, l), t.stateNode === null) Lr(e, t), Na(t, n, r), Cu(t, n, r, l), r = !0;
  else if (e === null) {
    var o = t.stateNode, i = t.memoizedProps;
    o.props = i;
    var s = o.context, c = n.contextType;
    typeof c == "object" && c !== null ? c = Te(c) : (c = ve(n) ? Tt : ie.current, c = rn(t, c));
    var h = n.getDerivedStateFromProps, m = typeof h == "function" || typeof o.getSnapshotBeforeUpdate == "function";
    m || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (i !== r || s !== c) && Ei(t, o, r, c), nt = !1;
    var p = t.memoizedState;
    o.state = p, Gr(t, r, o, l), s = t.memoizedState, i !== r || p !== s || he.current || nt ? (typeof h == "function" && (Eu(t, n, h, r), s = t.memoizedState), (i = nt || xi(t, n, i, r, p, s, c)) ? (m || typeof o.UNSAFE_componentWillMount != "function" && typeof o.componentWillMount != "function" || (typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount()), typeof o.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = s), o.props = r, o.state = s, o.context = c, r = i) : (typeof o.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
  } else {
    o = t.stateNode, ua(e, t), i = t.memoizedProps, c = t.type === t.elementType ? i : je(t.type, i), o.props = c, m = t.pendingProps, p = o.context, s = n.contextType, typeof s == "object" && s !== null ? s = Te(s) : (s = ve(n) ? Tt : ie.current, s = rn(t, s));
    var g = n.getDerivedStateFromProps;
    (h = typeof g == "function" || typeof o.getSnapshotBeforeUpdate == "function") || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (i !== m || p !== s) && Ei(t, o, r, s), nt = !1, p = t.memoizedState, o.state = p, Gr(t, r, o, l);
    var k = t.memoizedState;
    i !== m || p !== k || he.current || nt ? (typeof g == "function" && (Eu(t, n, g, r), k = t.memoizedState), (c = nt || xi(t, n, c, r, p, k, s) || !1) ? (h || typeof o.UNSAFE_componentWillUpdate != "function" && typeof o.componentWillUpdate != "function" || (typeof o.componentWillUpdate == "function" && o.componentWillUpdate(r, k, s), typeof o.UNSAFE_componentWillUpdate == "function" && o.UNSAFE_componentWillUpdate(r, k, s)), typeof o.componentDidUpdate == "function" && (t.flags |= 4), typeof o.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof o.componentDidUpdate != "function" || i === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || i === e.memoizedProps && p === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = k), o.props = r, o.state = k, o.context = s, r = c) : (typeof o.componentDidUpdate != "function" || i === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), typeof o.getSnapshotBeforeUpdate != "function" || i === e.memoizedProps && p === e.memoizedState || (t.flags |= 1024), r = !1);
  }
  return Pu(e, t, n, r, u, l);
}
function Pu(e, t, n, r, l, u) {
  Ra(e, t);
  var o = (t.flags & 128) !== 0;
  if (!r && !o) return l && mi(t, n, !1), qe(e, t, u);
  r = t.stateNode, ld.current = t;
  var i = o && typeof n.getDerivedStateFromError != "function" ? null : r.render();
  return t.flags |= 1, e !== null && o ? (t.child = un(t, e.child, null, u), t.child = un(t, null, i, u)) : ae(e, t, i, u), t.memoizedState = r.state, l && mi(t, n, !0), t.child;
}
function Oa(e) {
  var t = e.stateNode;
  t.pendingContext ? pi(e, t.pendingContext, t.pendingContext !== t.context) : t.context && pi(e, t.context, !1), mo(e, t.containerInfo);
}
function Li(e, t, n, r, l) {
  return ln(), io(l), t.flags |= 256, ae(e, t, n, r), t.child;
}
var zu = { dehydrated: null, treeContext: null, retryLane: 0 };
function Tu(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function ja(e, t, n) {
  var r = t.pendingProps, l = B.current, u = !1, o = (t.flags & 128) !== 0, i;
  if ((i = o) || (i = e !== null && e.memoizedState === null ? !1 : (l & 2) !== 0), i ? (u = !0, t.flags &= -129) : (e === null || e.memoizedState !== null) && (l |= 1), F(B, l & 1), e === null)
    return Su(t), e = t.memoizedState, e !== null && (e = e.dehydrated, e !== null) ? (t.mode & 1 ? e.data === "$!" ? t.lanes = 8 : t.lanes = 1073741824 : t.lanes = 1, null) : (o = r.children, e = r.fallback, u ? (r = t.mode, u = t.child, o = { mode: "hidden", children: o }, !(r & 1) && u !== null ? (u.childLanes = 0, u.pendingProps = o) : u = hl(o, r, 0, null), e = zt(e, r, n, null), u.return = t, e.return = t, u.sibling = e, t.child = u, t.child.memoizedState = Tu(n), t.memoizedState = zu, e) : xo(t, o));
  if (l = e.memoizedState, l !== null && (i = l.dehydrated, i !== null)) return ud(e, t, o, r, i, l, n);
  if (u) {
    u = r.fallback, o = t.mode, l = e.child, i = l.sibling;
    var s = { mode: "hidden", children: r.children };
    return !(o & 1) && t.child !== l ? (r = t.child, r.childLanes = 0, r.pendingProps = s, t.deletions = null) : (r = mt(l, s), r.subtreeFlags = l.subtreeFlags & 14680064), i !== null ? u = mt(i, u) : (u = zt(u, o, n, null), u.flags |= 2), u.return = t, r.return = t, r.sibling = u, t.child = r, r = u, u = t.child, o = e.child.memoizedState, o = o === null ? Tu(n) : { baseLanes: o.baseLanes | n, cachePool: null, transitions: o.transitions }, u.memoizedState = o, u.childLanes = e.childLanes & ~n, t.memoizedState = zu, r;
  }
  return u = e.child, e = u.sibling, r = mt(u, { mode: "visible", children: r.children }), !(t.mode & 1) && (r.lanes = n), r.return = t, r.sibling = null, e !== null && (n = t.deletions, n === null ? (t.deletions = [e], t.flags |= 16) : n.push(e)), t.child = r, t.memoizedState = null, r;
}
function xo(e, t) {
  return t = hl({ mode: "visible", children: t }, e.mode, 0, null), t.return = e, e.child = t;
}
function gr(e, t, n, r) {
  return r !== null && io(r), un(t, e.child, null, n), e = xo(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
}
function ud(e, t, n, r, l, u, o) {
  if (n)
    return t.flags & 256 ? (t.flags &= -257, r = Hl(Error(y(422))), gr(e, t, o, r)) : t.memoizedState !== null ? (t.child = e.child, t.flags |= 128, null) : (u = r.fallback, l = t.mode, r = hl({ mode: "visible", children: r.children }, l, 0, null), u = zt(u, l, o, null), u.flags |= 2, r.return = t, u.return = t, r.sibling = u, t.child = r, t.mode & 1 && un(t, e.child, null, o), t.child.memoizedState = Tu(o), t.memoizedState = zu, u);
  if (!(t.mode & 1)) return gr(e, t, o, null);
  if (l.data === "$!") {
    if (r = l.nextSibling && l.nextSibling.dataset, r) var i = r.dgst;
    return r = i, u = Error(y(419)), r = Hl(u, r, void 0), gr(e, t, o, r);
  }
  if (i = (o & e.childLanes) !== 0, me || i) {
    if (r = b, r !== null) {
      switch (o & -o) {
        case 4:
          l = 2;
          break;
        case 16:
          l = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          l = 32;
          break;
        case 536870912:
          l = 268435456;
          break;
        default:
          l = 0;
      }
      l = l & (r.suspendedLanes | o) ? 0 : l, l !== 0 && l !== u.retryLane && (u.retryLane = l, Je(e, l), Fe(r, e, l, -1));
    }
    return zo(), r = Hl(Error(y(421))), gr(e, t, o, r);
  }
  return l.data === "$?" ? (t.flags |= 128, t.child = e.child, t = gd.bind(null, e), l._reactRetry = t, null) : (e = u.treeContext, we = ct(l.nextSibling), ke = t, A = !0, De = null, e !== null && (_e[Ne++] = Ke, _e[Ne++] = Ye, _e[Ne++] = Lt, Ke = e.id, Ye = e.overflow, Lt = t), t = xo(t, r.children), t.flags |= 4096, t);
}
function Ri(e, t, n) {
  e.lanes |= t;
  var r = e.alternate;
  r !== null && (r.lanes |= t), xu(e.return, t, n);
}
function Wl(e, t, n, r, l) {
  var u = e.memoizedState;
  u === null ? e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: r, tail: n, tailMode: l } : (u.isBackwards = t, u.rendering = null, u.renderingStartTime = 0, u.last = r, u.tail = n, u.tailMode = l);
}
function Ma(e, t, n) {
  var r = t.pendingProps, l = r.revealOrder, u = r.tail;
  if (ae(e, t, r.children, n), r = B.current, r & 2) r = r & 1 | 2, t.flags |= 128;
  else {
    if (e !== null && e.flags & 128) e: for (e = t.child; e !== null; ) {
      if (e.tag === 13) e.memoizedState !== null && Ri(e, n, t);
      else if (e.tag === 19) Ri(e, n, t);
      else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break e;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) break e;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    r &= 1;
  }
  if (F(B, r), !(t.mode & 1)) t.memoizedState = null;
  else switch (l) {
    case "forwards":
      for (n = t.child, l = null; n !== null; ) e = n.alternate, e !== null && Zr(e) === null && (l = n), n = n.sibling;
      n = l, n === null ? (l = t.child, t.child = null) : (l = n.sibling, n.sibling = null), Wl(t, !1, l, n, u);
      break;
    case "backwards":
      for (n = null, l = t.child, t.child = null; l !== null; ) {
        if (e = l.alternate, e !== null && Zr(e) === null) {
          t.child = l;
          break;
        }
        e = l.sibling, l.sibling = n, n = l, l = e;
      }
      Wl(t, !0, n, null, u);
      break;
    case "together":
      Wl(t, !1, null, null, void 0);
      break;
    default:
      t.memoizedState = null;
  }
  return t.child;
}
function Lr(e, t) {
  !(t.mode & 1) && e !== null && (e.alternate = null, t.alternate = null, t.flags |= 2);
}
function qe(e, t, n) {
  if (e !== null && (t.dependencies = e.dependencies), Ot |= t.lanes, !(n & t.childLanes)) return null;
  if (e !== null && t.child !== e.child) throw Error(y(153));
  if (t.child !== null) {
    for (e = t.child, n = mt(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; ) e = e.sibling, n = n.sibling = mt(e, e.pendingProps), n.return = t;
    n.sibling = null;
  }
  return t.child;
}
function od(e, t, n) {
  switch (t.tag) {
    case 3:
      Oa(t), ln();
      break;
    case 5:
      oa(t);
      break;
    case 1:
      ve(t.type) && Wr(t);
      break;
    case 4:
      mo(t, t.stateNode.containerInfo);
      break;
    case 10:
      var r = t.type._context, l = t.memoizedProps.value;
      F(Yr, r._currentValue), r._currentValue = l;
      break;
    case 13:
      if (r = t.memoizedState, r !== null)
        return r.dehydrated !== null ? (F(B, B.current & 1), t.flags |= 128, null) : n & t.child.childLanes ? ja(e, t, n) : (F(B, B.current & 1), e = qe(e, t, n), e !== null ? e.sibling : null);
      F(B, B.current & 1);
      break;
    case 19:
      if (r = (n & t.childLanes) !== 0, e.flags & 128) {
        if (r) return Ma(e, t, n);
        t.flags |= 128;
      }
      if (l = t.memoizedState, l !== null && (l.rendering = null, l.tail = null, l.lastEffect = null), F(B, B.current), r) break;
      return null;
    case 22:
    case 23:
      return t.lanes = 0, La(e, t, n);
  }
  return qe(e, t, n);
}
var Da, Lu, Ia, Fa;
Da = function(e, t) {
  for (var n = t.child; n !== null; ) {
    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
    else if (n.tag !== 4 && n.child !== null) {
      n.child.return = n, n = n.child;
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    n.sibling.return = n.return, n = n.sibling;
  }
};
Lu = function() {
};
Ia = function(e, t, n, r) {
  var l = e.memoizedProps;
  if (l !== r) {
    e = t.stateNode, Nt(He.current);
    var u = null;
    switch (n) {
      case "input":
        l = ql(e, l), r = ql(e, r), u = [];
        break;
      case "select":
        l = W({}, l, { value: void 0 }), r = W({}, r, { value: void 0 }), u = [];
        break;
      case "textarea":
        l = tu(e, l), r = tu(e, r), u = [];
        break;
      default:
        typeof l.onClick != "function" && typeof r.onClick == "function" && (e.onclick = Br);
    }
    ru(n, r);
    var o;
    n = null;
    for (c in l) if (!r.hasOwnProperty(c) && l.hasOwnProperty(c) && l[c] != null) if (c === "style") {
      var i = l[c];
      for (o in i) i.hasOwnProperty(o) && (n || (n = {}), n[o] = "");
    } else c !== "dangerouslySetInnerHTML" && c !== "children" && c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && c !== "autoFocus" && (Mn.hasOwnProperty(c) ? u || (u = []) : (u = u || []).push(c, null));
    for (c in r) {
      var s = r[c];
      if (i = l != null ? l[c] : void 0, r.hasOwnProperty(c) && s !== i && (s != null || i != null)) if (c === "style") if (i) {
        for (o in i) !i.hasOwnProperty(o) || s && s.hasOwnProperty(o) || (n || (n = {}), n[o] = "");
        for (o in s) s.hasOwnProperty(o) && i[o] !== s[o] && (n || (n = {}), n[o] = s[o]);
      } else n || (u || (u = []), u.push(
        c,
        n
      )), n = s;
      else c === "dangerouslySetInnerHTML" ? (s = s ? s.__html : void 0, i = i ? i.__html : void 0, s != null && i !== s && (u = u || []).push(c, s)) : c === "children" ? typeof s != "string" && typeof s != "number" || (u = u || []).push(c, "" + s) : c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && (Mn.hasOwnProperty(c) ? (s != null && c === "onScroll" && U("scroll", e), u || i === s || (u = [])) : (u = u || []).push(c, s));
    }
    n && (u = u || []).push("style", n);
    var c = u;
    (t.updateQueue = c) && (t.flags |= 4);
  }
};
Fa = function(e, t, n, r) {
  n !== r && (t.flags |= 4);
};
function wn(e, t) {
  if (!A) switch (e.tailMode) {
    case "hidden":
      t = e.tail;
      for (var n = null; t !== null; ) t.alternate !== null && (n = t), t = t.sibling;
      n === null ? e.tail = null : n.sibling = null;
      break;
    case "collapsed":
      n = e.tail;
      for (var r = null; n !== null; ) n.alternate !== null && (r = n), n = n.sibling;
      r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
  }
}
function ue(e) {
  var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
  if (t) for (var l = e.child; l !== null; ) n |= l.lanes | l.childLanes, r |= l.subtreeFlags & 14680064, r |= l.flags & 14680064, l.return = e, l = l.sibling;
  else for (l = e.child; l !== null; ) n |= l.lanes | l.childLanes, r |= l.subtreeFlags, r |= l.flags, l.return = e, l = l.sibling;
  return e.subtreeFlags |= r, e.childLanes = n, t;
}
function id(e, t, n) {
  var r = t.pendingProps;
  switch (oo(t), t.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return ue(t), null;
    case 1:
      return ve(t.type) && Hr(), ue(t), null;
    case 3:
      return r = t.stateNode, on(), $(he), $(ie), vo(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (e === null || e.child === null) && (vr(t) ? t.flags |= 4 : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, De !== null && (Uu(De), De = null))), Lu(e, t), ue(t), null;
    case 5:
      ho(t);
      var l = Nt(Kn.current);
      if (n = t.type, e !== null && t.stateNode != null) Ia(e, t, n, r, l), e.ref !== t.ref && (t.flags |= 512, t.flags |= 2097152);
      else {
        if (!r) {
          if (t.stateNode === null) throw Error(y(166));
          return ue(t), null;
        }
        if (e = Nt(He.current), vr(t)) {
          r = t.stateNode, n = t.type;
          var u = t.memoizedProps;
          switch (r[Ve] = t, r[Wn] = u, e = (t.mode & 1) !== 0, n) {
            case "dialog":
              U("cancel", r), U("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              U("load", r);
              break;
            case "video":
            case "audio":
              for (l = 0; l < Cn.length; l++) U(Cn[l], r);
              break;
            case "source":
              U("error", r);
              break;
            case "img":
            case "image":
            case "link":
              U(
                "error",
                r
              ), U("load", r);
              break;
            case "details":
              U("toggle", r);
              break;
            case "input":
              Ao(r, u), U("invalid", r);
              break;
            case "select":
              r._wrapperState = { wasMultiple: !!u.multiple }, U("invalid", r);
              break;
            case "textarea":
              Bo(r, u), U("invalid", r);
          }
          ru(n, u), l = null;
          for (var o in u) if (u.hasOwnProperty(o)) {
            var i = u[o];
            o === "children" ? typeof i == "string" ? r.textContent !== i && (u.suppressHydrationWarning !== !0 && hr(r.textContent, i, e), l = ["children", i]) : typeof i == "number" && r.textContent !== "" + i && (u.suppressHydrationWarning !== !0 && hr(
              r.textContent,
              i,
              e
            ), l = ["children", "" + i]) : Mn.hasOwnProperty(o) && i != null && o === "onScroll" && U("scroll", r);
          }
          switch (n) {
            case "input":
              ir(r), Vo(r, u, !0);
              break;
            case "textarea":
              ir(r), Ho(r);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof u.onClick == "function" && (r.onclick = Br);
          }
          r = l, t.updateQueue = r, r !== null && (t.flags |= 4);
        } else {
          o = l.nodeType === 9 ? l : l.ownerDocument, e === "http://www.w3.org/1999/xhtml" && (e = fs(n)), e === "http://www.w3.org/1999/xhtml" ? n === "script" ? (e = o.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : typeof r.is == "string" ? e = o.createElement(n, { is: r.is }) : (e = o.createElement(n), n === "select" && (o = e, r.multiple ? o.multiple = !0 : r.size && (o.size = r.size))) : e = o.createElementNS(e, n), e[Ve] = t, e[Wn] = r, Da(e, t, !1, !1), t.stateNode = e;
          e: {
            switch (o = lu(n, r), n) {
              case "dialog":
                U("cancel", e), U("close", e), l = r;
                break;
              case "iframe":
              case "object":
              case "embed":
                U("load", e), l = r;
                break;
              case "video":
              case "audio":
                for (l = 0; l < Cn.length; l++) U(Cn[l], e);
                l = r;
                break;
              case "source":
                U("error", e), l = r;
                break;
              case "img":
              case "image":
              case "link":
                U(
                  "error",
                  e
                ), U("load", e), l = r;
                break;
              case "details":
                U("toggle", e), l = r;
                break;
              case "input":
                Ao(e, r), l = ql(e, r), U("invalid", e);
                break;
              case "option":
                l = r;
                break;
              case "select":
                e._wrapperState = { wasMultiple: !!r.multiple }, l = W({}, r, { value: void 0 }), U("invalid", e);
                break;
              case "textarea":
                Bo(e, r), l = tu(e, r), U("invalid", e);
                break;
              default:
                l = r;
            }
            ru(n, l), i = l;
            for (u in i) if (i.hasOwnProperty(u)) {
              var s = i[u];
              u === "style" ? ms(e, s) : u === "dangerouslySetInnerHTML" ? (s = s ? s.__html : void 0, s != null && ds(e, s)) : u === "children" ? typeof s == "string" ? (n !== "textarea" || s !== "") && Dn(e, s) : typeof s == "number" && Dn(e, "" + s) : u !== "suppressContentEditableWarning" && u !== "suppressHydrationWarning" && u !== "autoFocus" && (Mn.hasOwnProperty(u) ? s != null && u === "onScroll" && U("scroll", e) : s != null && Qu(e, u, s, o));
            }
            switch (n) {
              case "input":
                ir(e), Vo(e, r, !1);
                break;
              case "textarea":
                ir(e), Ho(e);
                break;
              case "option":
                r.value != null && e.setAttribute("value", "" + ht(r.value));
                break;
              case "select":
                e.multiple = !!r.multiple, u = r.value, u != null ? Zt(e, !!r.multiple, u, !1) : r.defaultValue != null && Zt(
                  e,
                  !!r.multiple,
                  r.defaultValue,
                  !0
                );
                break;
              default:
                typeof l.onClick == "function" && (e.onclick = Br);
            }
            switch (n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
          }
          r && (t.flags |= 4);
        }
        t.ref !== null && (t.flags |= 512, t.flags |= 2097152);
      }
      return ue(t), null;
    case 6:
      if (e && t.stateNode != null) Fa(e, t, e.memoizedProps, r);
      else {
        if (typeof r != "string" && t.stateNode === null) throw Error(y(166));
        if (n = Nt(Kn.current), Nt(He.current), vr(t)) {
          if (r = t.stateNode, n = t.memoizedProps, r[Ve] = t, (u = r.nodeValue !== n) && (e = ke, e !== null)) switch (e.tag) {
            case 3:
              hr(r.nodeValue, n, (e.mode & 1) !== 0);
              break;
            case 5:
              e.memoizedProps.suppressHydrationWarning !== !0 && hr(r.nodeValue, n, (e.mode & 1) !== 0);
          }
          u && (t.flags |= 4);
        } else r = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(r), r[Ve] = t, t.stateNode = r;
      }
      return ue(t), null;
    case 13:
      if ($(B), r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
        if (A && we !== null && t.mode & 1 && !(t.flags & 128)) ta(), ln(), t.flags |= 98560, u = !1;
        else if (u = vr(t), r !== null && r.dehydrated !== null) {
          if (e === null) {
            if (!u) throw Error(y(318));
            if (u = t.memoizedState, u = u !== null ? u.dehydrated : null, !u) throw Error(y(317));
            u[Ve] = t;
          } else ln(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
          ue(t), u = !1;
        } else De !== null && (Uu(De), De = null), u = !0;
        if (!u) return t.flags & 65536 ? t : null;
      }
      return t.flags & 128 ? (t.lanes = n, t) : (r = r !== null, r !== (e !== null && e.memoizedState !== null) && r && (t.child.flags |= 8192, t.mode & 1 && (e === null || B.current & 1 ? Z === 0 && (Z = 3) : zo())), t.updateQueue !== null && (t.flags |= 4), ue(t), null);
    case 4:
      return on(), Lu(e, t), e === null && Bn(t.stateNode.containerInfo), ue(t), null;
    case 10:
      return co(t.type._context), ue(t), null;
    case 17:
      return ve(t.type) && Hr(), ue(t), null;
    case 19:
      if ($(B), u = t.memoizedState, u === null) return ue(t), null;
      if (r = (t.flags & 128) !== 0, o = u.rendering, o === null) if (r) wn(u, !1);
      else {
        if (Z !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null; ) {
          if (o = Zr(e), o !== null) {
            for (t.flags |= 128, wn(u, !1), r = o.updateQueue, r !== null && (t.updateQueue = r, t.flags |= 4), t.subtreeFlags = 0, r = n, n = t.child; n !== null; ) u = n, e = r, u.flags &= 14680066, o = u.alternate, o === null ? (u.childLanes = 0, u.lanes = e, u.child = null, u.subtreeFlags = 0, u.memoizedProps = null, u.memoizedState = null, u.updateQueue = null, u.dependencies = null, u.stateNode = null) : (u.childLanes = o.childLanes, u.lanes = o.lanes, u.child = o.child, u.subtreeFlags = 0, u.deletions = null, u.memoizedProps = o.memoizedProps, u.memoizedState = o.memoizedState, u.updateQueue = o.updateQueue, u.type = o.type, e = o.dependencies, u.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }), n = n.sibling;
            return F(B, B.current & 1 | 2), t.child;
          }
          e = e.sibling;
        }
        u.tail !== null && K() > an && (t.flags |= 128, r = !0, wn(u, !1), t.lanes = 4194304);
      }
      else {
        if (!r) if (e = Zr(o), e !== null) {
          if (t.flags |= 128, r = !0, n = e.updateQueue, n !== null && (t.updateQueue = n, t.flags |= 4), wn(u, !0), u.tail === null && u.tailMode === "hidden" && !o.alternate && !A) return ue(t), null;
        } else 2 * K() - u.renderingStartTime > an && n !== 1073741824 && (t.flags |= 128, r = !0, wn(u, !1), t.lanes = 4194304);
        u.isBackwards ? (o.sibling = t.child, t.child = o) : (n = u.last, n !== null ? n.sibling = o : t.child = o, u.last = o);
      }
      return u.tail !== null ? (t = u.tail, u.rendering = t, u.tail = t.sibling, u.renderingStartTime = K(), t.sibling = null, n = B.current, F(B, r ? n & 1 | 2 : n & 1), t) : (ue(t), null);
    case 22:
    case 23:
      return Po(), r = t.memoizedState !== null, e !== null && e.memoizedState !== null !== r && (t.flags |= 8192), r && t.mode & 1 ? ge & 1073741824 && (ue(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : ue(t), null;
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(y(156, t.tag));
}
function sd(e, t) {
  switch (oo(t), t.tag) {
    case 1:
      return ve(t.type) && Hr(), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 3:
      return on(), $(he), $(ie), vo(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
    case 5:
      return ho(t), null;
    case 13:
      if ($(B), e = t.memoizedState, e !== null && e.dehydrated !== null) {
        if (t.alternate === null) throw Error(y(340));
        ln();
      }
      return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
    case 19:
      return $(B), null;
    case 4:
      return on(), null;
    case 10:
      return co(t.type._context), null;
    case 22:
    case 23:
      return Po(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var wr = !1, oe = !1, ad = typeof WeakSet == "function" ? WeakSet : Set, E = null;
function Xt(e, t) {
  var n = e.ref;
  if (n !== null) if (typeof n == "function") try {
    n(null);
  } catch (r) {
    Q(e, t, r);
  }
  else n.current = null;
}
function Ru(e, t, n) {
  try {
    n();
  } catch (r) {
    Q(e, t, r);
  }
}
var Oi = !1;
function cd(e, t) {
  if (mu = $r, e = Bs(), lo(e)) {
    if ("selectionStart" in e) var n = { start: e.selectionStart, end: e.selectionEnd };
    else e: {
      n = (n = e.ownerDocument) && n.defaultView || window;
      var r = n.getSelection && n.getSelection();
      if (r && r.rangeCount !== 0) {
        n = r.anchorNode;
        var l = r.anchorOffset, u = r.focusNode;
        r = r.focusOffset;
        try {
          n.nodeType, u.nodeType;
        } catch {
          n = null;
          break e;
        }
        var o = 0, i = -1, s = -1, c = 0, h = 0, m = e, p = null;
        t: for (; ; ) {
          for (var g; m !== n || l !== 0 && m.nodeType !== 3 || (i = o + l), m !== u || r !== 0 && m.nodeType !== 3 || (s = o + r), m.nodeType === 3 && (o += m.nodeValue.length), (g = m.firstChild) !== null; )
            p = m, m = g;
          for (; ; ) {
            if (m === e) break t;
            if (p === n && ++c === l && (i = o), p === u && ++h === r && (s = o), (g = m.nextSibling) !== null) break;
            m = p, p = m.parentNode;
          }
          m = g;
        }
        n = i === -1 || s === -1 ? null : { start: i, end: s };
      } else n = null;
    }
    n = n || { start: 0, end: 0 };
  } else n = null;
  for (hu = { focusedElem: e, selectionRange: n }, $r = !1, E = t; E !== null; ) if (t = E, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null) e.return = t, E = e;
  else for (; E !== null; ) {
    t = E;
    try {
      var k = t.alternate;
      if (t.flags & 1024) switch (t.tag) {
        case 0:
        case 11:
        case 15:
          break;
        case 1:
          if (k !== null) {
            var w = k.memoizedProps, M = k.memoizedState, f = t.stateNode, a = f.getSnapshotBeforeUpdate(t.elementType === t.type ? w : je(t.type, w), M);
            f.__reactInternalSnapshotBeforeUpdate = a;
          }
          break;
        case 3:
          var d = t.stateNode.containerInfo;
          d.nodeType === 1 ? d.textContent = "" : d.nodeType === 9 && d.documentElement && d.removeChild(d.documentElement);
          break;
        case 5:
        case 6:
        case 4:
        case 17:
          break;
        default:
          throw Error(y(163));
      }
    } catch (v) {
      Q(t, t.return, v);
    }
    if (e = t.sibling, e !== null) {
      e.return = t.return, E = e;
      break;
    }
    E = t.return;
  }
  return k = Oi, Oi = !1, k;
}
function Rn(e, t, n) {
  var r = t.updateQueue;
  if (r = r !== null ? r.lastEffect : null, r !== null) {
    var l = r = r.next;
    do {
      if ((l.tag & e) === e) {
        var u = l.destroy;
        l.destroy = void 0, u !== void 0 && Ru(t, n, u);
      }
      l = l.next;
    } while (l !== r);
  }
}
function pl(e, t) {
  if (t = t.updateQueue, t = t !== null ? t.lastEffect : null, t !== null) {
    var n = t = t.next;
    do {
      if ((n.tag & e) === e) {
        var r = n.create;
        n.destroy = r();
      }
      n = n.next;
    } while (n !== t);
  }
}
function Ou(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == "function" ? t(e) : t.current = e;
  }
}
function Ua(e) {
  var t = e.alternate;
  t !== null && (e.alternate = null, Ua(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && (delete t[Ve], delete t[Wn], delete t[gu], delete t[Kf], delete t[Yf])), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
}
function $a(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function ji(e) {
  e: for (; ; ) {
    for (; e.sibling === null; ) {
      if (e.return === null || $a(e.return)) return null;
      e = e.return;
    }
    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      e.child.return = e, e = e.child;
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function ju(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.nodeType === 8 ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (n.nodeType === 8 ? (t = n.parentNode, t.insertBefore(e, n)) : (t = n, t.appendChild(e)), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = Br));
  else if (r !== 4 && (e = e.child, e !== null)) for (ju(e, t, n), e = e.sibling; e !== null; ) ju(e, t, n), e = e.sibling;
}
function Mu(e, t, n) {
  var r = e.tag;
  if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
  else if (r !== 4 && (e = e.child, e !== null)) for (Mu(e, t, n), e = e.sibling; e !== null; ) Mu(e, t, n), e = e.sibling;
}
var te = null, Me = !1;
function et(e, t, n) {
  for (n = n.child; n !== null; ) Aa(e, t, n), n = n.sibling;
}
function Aa(e, t, n) {
  if (Be && typeof Be.onCommitFiberUnmount == "function") try {
    Be.onCommitFiberUnmount(ul, n);
  } catch {
  }
  switch (n.tag) {
    case 5:
      oe || Xt(n, t);
    case 6:
      var r = te, l = Me;
      te = null, et(e, t, n), te = r, Me = l, te !== null && (Me ? (e = te, n = n.stateNode, e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n)) : te.removeChild(n.stateNode));
      break;
    case 18:
      te !== null && (Me ? (e = te, n = n.stateNode, e.nodeType === 8 ? Fl(e.parentNode, n) : e.nodeType === 1 && Fl(e, n), $n(e)) : Fl(te, n.stateNode));
      break;
    case 4:
      r = te, l = Me, te = n.stateNode.containerInfo, Me = !0, et(e, t, n), te = r, Me = l;
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!oe && (r = n.updateQueue, r !== null && (r = r.lastEffect, r !== null))) {
        l = r = r.next;
        do {
          var u = l, o = u.destroy;
          u = u.tag, o !== void 0 && (u & 2 || u & 4) && Ru(n, t, o), l = l.next;
        } while (l !== r);
      }
      et(e, t, n);
      break;
    case 1:
      if (!oe && (Xt(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function")) try {
        r.props = n.memoizedProps, r.state = n.memoizedState, r.componentWillUnmount();
      } catch (i) {
        Q(n, t, i);
      }
      et(e, t, n);
      break;
    case 21:
      et(e, t, n);
      break;
    case 22:
      n.mode & 1 ? (oe = (r = oe) || n.memoizedState !== null, et(e, t, n), oe = r) : et(e, t, n);
      break;
    default:
      et(e, t, n);
  }
}
function Mi(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    n === null && (n = e.stateNode = new ad()), t.forEach(function(r) {
      var l = wd.bind(null, e, r);
      n.has(r) || (n.add(r), r.then(l, l));
    });
  }
}
function Oe(e, t) {
  var n = t.deletions;
  if (n !== null) for (var r = 0; r < n.length; r++) {
    var l = n[r];
    try {
      var u = e, o = t, i = o;
      e: for (; i !== null; ) {
        switch (i.tag) {
          case 5:
            te = i.stateNode, Me = !1;
            break e;
          case 3:
            te = i.stateNode.containerInfo, Me = !0;
            break e;
          case 4:
            te = i.stateNode.containerInfo, Me = !0;
            break e;
        }
        i = i.return;
      }
      if (te === null) throw Error(y(160));
      Aa(u, o, l), te = null, Me = !1;
      var s = l.alternate;
      s !== null && (s.return = null), l.return = null;
    } catch (c) {
      Q(l, t, c);
    }
  }
  if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) Va(t, e), t = t.sibling;
}
function Va(e, t) {
  var n = e.alternate, r = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if (Oe(t, e), $e(e), r & 4) {
        try {
          Rn(3, e, e.return), pl(3, e);
        } catch (w) {
          Q(e, e.return, w);
        }
        try {
          Rn(5, e, e.return);
        } catch (w) {
          Q(e, e.return, w);
        }
      }
      break;
    case 1:
      Oe(t, e), $e(e), r & 512 && n !== null && Xt(n, n.return);
      break;
    case 5:
      if (Oe(t, e), $e(e), r & 512 && n !== null && Xt(n, n.return), e.flags & 32) {
        var l = e.stateNode;
        try {
          Dn(l, "");
        } catch (w) {
          Q(e, e.return, w);
        }
      }
      if (r & 4 && (l = e.stateNode, l != null)) {
        var u = e.memoizedProps, o = n !== null ? n.memoizedProps : u, i = e.type, s = e.updateQueue;
        if (e.updateQueue = null, s !== null) try {
          i === "input" && u.type === "radio" && u.name != null && as(l, u), lu(i, o);
          var c = lu(i, u);
          for (o = 0; o < s.length; o += 2) {
            var h = s[o], m = s[o + 1];
            h === "style" ? ms(l, m) : h === "dangerouslySetInnerHTML" ? ds(l, m) : h === "children" ? Dn(l, m) : Qu(l, h, m, c);
          }
          switch (i) {
            case "input":
              bl(l, u);
              break;
            case "textarea":
              cs(l, u);
              break;
            case "select":
              var p = l._wrapperState.wasMultiple;
              l._wrapperState.wasMultiple = !!u.multiple;
              var g = u.value;
              g != null ? Zt(l, !!u.multiple, g, !1) : p !== !!u.multiple && (u.defaultValue != null ? Zt(
                l,
                !!u.multiple,
                u.defaultValue,
                !0
              ) : Zt(l, !!u.multiple, u.multiple ? [] : "", !1));
          }
          l[Wn] = u;
        } catch (w) {
          Q(e, e.return, w);
        }
      }
      break;
    case 6:
      if (Oe(t, e), $e(e), r & 4) {
        if (e.stateNode === null) throw Error(y(162));
        l = e.stateNode, u = e.memoizedProps;
        try {
          l.nodeValue = u;
        } catch (w) {
          Q(e, e.return, w);
        }
      }
      break;
    case 3:
      if (Oe(t, e), $e(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
        $n(t.containerInfo);
      } catch (w) {
        Q(e, e.return, w);
      }
      break;
    case 4:
      Oe(t, e), $e(e);
      break;
    case 13:
      Oe(t, e), $e(e), l = e.child, l.flags & 8192 && (u = l.memoizedState !== null, l.stateNode.isHidden = u, !u || l.alternate !== null && l.alternate.memoizedState !== null || (_o = K())), r & 4 && Mi(e);
      break;
    case 22:
      if (h = n !== null && n.memoizedState !== null, e.mode & 1 ? (oe = (c = oe) || h, Oe(t, e), oe = c) : Oe(t, e), $e(e), r & 8192) {
        if (c = e.memoizedState !== null, (e.stateNode.isHidden = c) && !h && e.mode & 1) for (E = e, h = e.child; h !== null; ) {
          for (m = E = h; E !== null; ) {
            switch (p = E, g = p.child, p.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Rn(4, p, p.return);
                break;
              case 1:
                Xt(p, p.return);
                var k = p.stateNode;
                if (typeof k.componentWillUnmount == "function") {
                  r = p, n = p.return;
                  try {
                    t = r, k.props = t.memoizedProps, k.state = t.memoizedState, k.componentWillUnmount();
                  } catch (w) {
                    Q(r, n, w);
                  }
                }
                break;
              case 5:
                Xt(p, p.return);
                break;
              case 22:
                if (p.memoizedState !== null) {
                  Ii(m);
                  continue;
                }
            }
            g !== null ? (g.return = p, E = g) : Ii(m);
          }
          h = h.sibling;
        }
        e: for (h = null, m = e; ; ) {
          if (m.tag === 5) {
            if (h === null) {
              h = m;
              try {
                l = m.stateNode, c ? (u = l.style, typeof u.setProperty == "function" ? u.setProperty("display", "none", "important") : u.display = "none") : (i = m.stateNode, s = m.memoizedProps.style, o = s != null && s.hasOwnProperty("display") ? s.display : null, i.style.display = ps("display", o));
              } catch (w) {
                Q(e, e.return, w);
              }
            }
          } else if (m.tag === 6) {
            if (h === null) try {
              m.stateNode.nodeValue = c ? "" : m.memoizedProps;
            } catch (w) {
              Q(e, e.return, w);
            }
          } else if ((m.tag !== 22 && m.tag !== 23 || m.memoizedState === null || m === e) && m.child !== null) {
            m.child.return = m, m = m.child;
            continue;
          }
          if (m === e) break e;
          for (; m.sibling === null; ) {
            if (m.return === null || m.return === e) break e;
            h === m && (h = null), m = m.return;
          }
          h === m && (h = null), m.sibling.return = m.return, m = m.sibling;
        }
      }
      break;
    case 19:
      Oe(t, e), $e(e), r & 4 && Mi(e);
      break;
    case 21:
      break;
    default:
      Oe(
        t,
        e
      ), $e(e);
  }
}
function $e(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null; ) {
          if ($a(n)) {
            var r = n;
            break e;
          }
          n = n.return;
        }
        throw Error(y(160));
      }
      switch (r.tag) {
        case 5:
          var l = r.stateNode;
          r.flags & 32 && (Dn(l, ""), r.flags &= -33);
          var u = ji(e);
          Mu(e, u, l);
          break;
        case 3:
        case 4:
          var o = r.stateNode.containerInfo, i = ji(e);
          ju(e, i, o);
          break;
        default:
          throw Error(y(161));
      }
    } catch (s) {
      Q(e, e.return, s);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function fd(e, t, n) {
  E = e, Ba(e);
}
function Ba(e, t, n) {
  for (var r = (e.mode & 1) !== 0; E !== null; ) {
    var l = E, u = l.child;
    if (l.tag === 22 && r) {
      var o = l.memoizedState !== null || wr;
      if (!o) {
        var i = l.alternate, s = i !== null && i.memoizedState !== null || oe;
        i = wr;
        var c = oe;
        if (wr = o, (oe = s) && !c) for (E = l; E !== null; ) o = E, s = o.child, o.tag === 22 && o.memoizedState !== null ? Fi(l) : s !== null ? (s.return = o, E = s) : Fi(l);
        for (; u !== null; ) E = u, Ba(u), u = u.sibling;
        E = l, wr = i, oe = c;
      }
      Di(e);
    } else l.subtreeFlags & 8772 && u !== null ? (u.return = l, E = u) : Di(e);
  }
}
function Di(e) {
  for (; E !== null; ) {
    var t = E;
    if (t.flags & 8772) {
      var n = t.alternate;
      try {
        if (t.flags & 8772) switch (t.tag) {
          case 0:
          case 11:
          case 15:
            oe || pl(5, t);
            break;
          case 1:
            var r = t.stateNode;
            if (t.flags & 4 && !oe) if (n === null) r.componentDidMount();
            else {
              var l = t.elementType === t.type ? n.memoizedProps : je(t.type, n.memoizedProps);
              r.componentDidUpdate(l, n.memoizedState, r.__reactInternalSnapshotBeforeUpdate);
            }
            var u = t.updateQueue;
            u !== null && wi(t, u, r);
            break;
          case 3:
            var o = t.updateQueue;
            if (o !== null) {
              if (n = null, t.child !== null) switch (t.child.tag) {
                case 5:
                  n = t.child.stateNode;
                  break;
                case 1:
                  n = t.child.stateNode;
              }
              wi(t, o, n);
            }
            break;
          case 5:
            var i = t.stateNode;
            if (n === null && t.flags & 4) {
              n = i;
              var s = t.memoizedProps;
              switch (t.type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  s.autoFocus && n.focus();
                  break;
                case "img":
                  s.src && (n.src = s.src);
              }
            }
            break;
          case 6:
            break;
          case 4:
            break;
          case 12:
            break;
          case 13:
            if (t.memoizedState === null) {
              var c = t.alternate;
              if (c !== null) {
                var h = c.memoizedState;
                if (h !== null) {
                  var m = h.dehydrated;
                  m !== null && $n(m);
                }
              }
            }
            break;
          case 19:
          case 17:
          case 21:
          case 22:
          case 23:
          case 25:
            break;
          default:
            throw Error(y(163));
        }
        oe || t.flags & 512 && Ou(t);
      } catch (p) {
        Q(t, t.return, p);
      }
    }
    if (t === e) {
      E = null;
      break;
    }
    if (n = t.sibling, n !== null) {
      n.return = t.return, E = n;
      break;
    }
    E = t.return;
  }
}
function Ii(e) {
  for (; E !== null; ) {
    var t = E;
    if (t === e) {
      E = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      n.return = t.return, E = n;
      break;
    }
    E = t.return;
  }
}
function Fi(e) {
  for (; E !== null; ) {
    var t = E;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            pl(4, t);
          } catch (s) {
            Q(t, n, s);
          }
          break;
        case 1:
          var r = t.stateNode;
          if (typeof r.componentDidMount == "function") {
            var l = t.return;
            try {
              r.componentDidMount();
            } catch (s) {
              Q(t, l, s);
            }
          }
          var u = t.return;
          try {
            Ou(t);
          } catch (s) {
            Q(t, u, s);
          }
          break;
        case 5:
          var o = t.return;
          try {
            Ou(t);
          } catch (s) {
            Q(t, o, s);
          }
      }
    } catch (s) {
      Q(t, t.return, s);
    }
    if (t === e) {
      E = null;
      break;
    }
    var i = t.sibling;
    if (i !== null) {
      i.return = t.return, E = i;
      break;
    }
    E = t.return;
  }
}
var dd = Math.ceil, br = be.ReactCurrentDispatcher, Eo = be.ReactCurrentOwner, ze = be.ReactCurrentBatchConfig, R = 0, b = null, X = null, ne = 0, ge = 0, Gt = gt(0), Z = 0, Zn = null, Ot = 0, ml = 0, Co = 0, On = null, pe = null, _o = 0, an = 1 / 0, We = null, el = !1, Du = null, dt = null, kr = !1, ot = null, tl = 0, jn = 0, Iu = null, Rr = -1, Or = 0;
function ce() {
  return R & 6 ? K() : Rr !== -1 ? Rr : Rr = K();
}
function pt(e) {
  return e.mode & 1 ? R & 2 && ne !== 0 ? ne & -ne : Gf.transition !== null ? (Or === 0 && (Or = Ns()), Or) : (e = j, e !== 0 || (e = window.event, e = e === void 0 ? 16 : js(e.type)), e) : 1;
}
function Fe(e, t, n, r) {
  if (50 < jn) throw jn = 0, Iu = null, Error(y(185));
  qn(e, n, r), (!(R & 2) || e !== b) && (e === b && (!(R & 2) && (ml |= n), Z === 4 && lt(e, ne)), ye(e, r), n === 1 && R === 0 && !(t.mode & 1) && (an = K() + 500, cl && wt()));
}
function ye(e, t) {
  var n = e.callbackNode;
  Xc(e, t);
  var r = Ur(e, e === b ? ne : 0);
  if (r === 0) n !== null && Ko(n), e.callbackNode = null, e.callbackPriority = 0;
  else if (t = r & -r, e.callbackPriority !== t) {
    if (n != null && Ko(n), t === 1) e.tag === 0 ? Xf(Ui.bind(null, e)) : qs(Ui.bind(null, e)), Wf(function() {
      !(R & 6) && wt();
    }), n = null;
    else {
      switch (Ps(r)) {
        case 1:
          n = Zu;
          break;
        case 4:
          n = Cs;
          break;
        case 16:
          n = Fr;
          break;
        case 536870912:
          n = _s;
          break;
        default:
          n = Fr;
      }
      n = Za(n, Ha.bind(null, e));
    }
    e.callbackPriority = t, e.callbackNode = n;
  }
}
function Ha(e, t) {
  if (Rr = -1, Or = 0, R & 6) throw Error(y(327));
  var n = e.callbackNode;
  if (tn() && e.callbackNode !== n) return null;
  var r = Ur(e, e === b ? ne : 0);
  if (r === 0) return null;
  if (r & 30 || r & e.expiredLanes || t) t = nl(e, r);
  else {
    t = r;
    var l = R;
    R |= 2;
    var u = Qa();
    (b !== e || ne !== t) && (We = null, an = K() + 500, Pt(e, t));
    do
      try {
        hd();
        break;
      } catch (i) {
        Wa(e, i);
      }
    while (!0);
    ao(), br.current = u, R = l, X !== null ? t = 0 : (b = null, ne = 0, t = Z);
  }
  if (t !== 0) {
    if (t === 2 && (l = au(e), l !== 0 && (r = l, t = Fu(e, l))), t === 1) throw n = Zn, Pt(e, 0), lt(e, r), ye(e, K()), n;
    if (t === 6) lt(e, r);
    else {
      if (l = e.current.alternate, !(r & 30) && !pd(l) && (t = nl(e, r), t === 2 && (u = au(e), u !== 0 && (r = u, t = Fu(e, u))), t === 1)) throw n = Zn, Pt(e, 0), lt(e, r), ye(e, K()), n;
      switch (e.finishedWork = l, e.finishedLanes = r, t) {
        case 0:
        case 1:
          throw Error(y(345));
        case 2:
          Et(e, pe, We);
          break;
        case 3:
          if (lt(e, r), (r & 130023424) === r && (t = _o + 500 - K(), 10 < t)) {
            if (Ur(e, 0) !== 0) break;
            if (l = e.suspendedLanes, (l & r) !== r) {
              ce(), e.pingedLanes |= e.suspendedLanes & l;
              break;
            }
            e.timeoutHandle = yu(Et.bind(null, e, pe, We), t);
            break;
          }
          Et(e, pe, We);
          break;
        case 4:
          if (lt(e, r), (r & 4194240) === r) break;
          for (t = e.eventTimes, l = -1; 0 < r; ) {
            var o = 31 - Ie(r);
            u = 1 << o, o = t[o], o > l && (l = o), r &= ~u;
          }
          if (r = l, r = K() - r, r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * dd(r / 1960)) - r, 10 < r) {
            e.timeoutHandle = yu(Et.bind(null, e, pe, We), r);
            break;
          }
          Et(e, pe, We);
          break;
        case 5:
          Et(e, pe, We);
          break;
        default:
          throw Error(y(329));
      }
    }
  }
  return ye(e, K()), e.callbackNode === n ? Ha.bind(null, e) : null;
}
function Fu(e, t) {
  var n = On;
  return e.current.memoizedState.isDehydrated && (Pt(e, t).flags |= 256), e = nl(e, t), e !== 2 && (t = pe, pe = n, t !== null && Uu(t)), e;
}
function Uu(e) {
  pe === null ? pe = e : pe.push.apply(pe, e);
}
function pd(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && (n = n.stores, n !== null)) for (var r = 0; r < n.length; r++) {
        var l = n[r], u = l.getSnapshot;
        l = l.value;
        try {
          if (!Ue(u(), l)) return !1;
        } catch {
          return !1;
        }
      }
    }
    if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
    else {
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
  }
  return !0;
}
function lt(e, t) {
  for (t &= ~Co, t &= ~ml, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
    var n = 31 - Ie(t), r = 1 << n;
    e[n] = -1, t &= ~r;
  }
}
function Ui(e) {
  if (R & 6) throw Error(y(327));
  tn();
  var t = Ur(e, 0);
  if (!(t & 1)) return ye(e, K()), null;
  var n = nl(e, t);
  if (e.tag !== 0 && n === 2) {
    var r = au(e);
    r !== 0 && (t = r, n = Fu(e, r));
  }
  if (n === 1) throw n = Zn, Pt(e, 0), lt(e, t), ye(e, K()), n;
  if (n === 6) throw Error(y(345));
  return e.finishedWork = e.current.alternate, e.finishedLanes = t, Et(e, pe, We), ye(e, K()), null;
}
function No(e, t) {
  var n = R;
  R |= 1;
  try {
    return e(t);
  } finally {
    R = n, R === 0 && (an = K() + 500, cl && wt());
  }
}
function jt(e) {
  ot !== null && ot.tag === 0 && !(R & 6) && tn();
  var t = R;
  R |= 1;
  var n = ze.transition, r = j;
  try {
    if (ze.transition = null, j = 1, e) return e();
  } finally {
    j = r, ze.transition = n, R = t, !(R & 6) && wt();
  }
}
function Po() {
  ge = Gt.current, $(Gt);
}
function Pt(e, t) {
  e.finishedWork = null, e.finishedLanes = 0;
  var n = e.timeoutHandle;
  if (n !== -1 && (e.timeoutHandle = -1, Hf(n)), X !== null) for (n = X.return; n !== null; ) {
    var r = n;
    switch (oo(r), r.tag) {
      case 1:
        r = r.type.childContextTypes, r != null && Hr();
        break;
      case 3:
        on(), $(he), $(ie), vo();
        break;
      case 5:
        ho(r);
        break;
      case 4:
        on();
        break;
      case 13:
        $(B);
        break;
      case 19:
        $(B);
        break;
      case 10:
        co(r.type._context);
        break;
      case 22:
      case 23:
        Po();
    }
    n = n.return;
  }
  if (b = e, X = e = mt(e.current, null), ne = ge = t, Z = 0, Zn = null, Co = ml = Ot = 0, pe = On = null, _t !== null) {
    for (t = 0; t < _t.length; t++) if (n = _t[t], r = n.interleaved, r !== null) {
      n.interleaved = null;
      var l = r.next, u = n.pending;
      if (u !== null) {
        var o = u.next;
        u.next = l, r.next = o;
      }
      n.pending = r;
    }
    _t = null;
  }
  return e;
}
function Wa(e, t) {
  do {
    var n = X;
    try {
      if (ao(), zr.current = qr, Jr) {
        for (var r = H.memoizedState; r !== null; ) {
          var l = r.queue;
          l !== null && (l.pending = null), r = r.next;
        }
        Jr = !1;
      }
      if (Rt = 0, q = G = H = null, Ln = !1, Yn = 0, Eo.current = null, n === null || n.return === null) {
        Z = 1, Zn = t, X = null;
        break;
      }
      e: {
        var u = e, o = n.return, i = n, s = t;
        if (t = ne, i.flags |= 32768, s !== null && typeof s == "object" && typeof s.then == "function") {
          var c = s, h = i, m = h.tag;
          if (!(h.mode & 1) && (m === 0 || m === 11 || m === 15)) {
            var p = h.alternate;
            p ? (h.updateQueue = p.updateQueue, h.memoizedState = p.memoizedState, h.lanes = p.lanes) : (h.updateQueue = null, h.memoizedState = null);
          }
          var g = _i(o);
          if (g !== null) {
            g.flags &= -257, Ni(g, o, i, u, t), g.mode & 1 && Ci(u, c, t), t = g, s = c;
            var k = t.updateQueue;
            if (k === null) {
              var w = /* @__PURE__ */ new Set();
              w.add(s), t.updateQueue = w;
            } else k.add(s);
            break e;
          } else {
            if (!(t & 1)) {
              Ci(u, c, t), zo();
              break e;
            }
            s = Error(y(426));
          }
        } else if (A && i.mode & 1) {
          var M = _i(o);
          if (M !== null) {
            !(M.flags & 65536) && (M.flags |= 256), Ni(M, o, i, u, t), io(sn(s, i));
            break e;
          }
        }
        u = s = sn(s, i), Z !== 4 && (Z = 2), On === null ? On = [u] : On.push(u), u = o;
        do {
          switch (u.tag) {
            case 3:
              u.flags |= 65536, t &= -t, u.lanes |= t;
              var f = Pa(u, s, t);
              gi(u, f);
              break e;
            case 1:
              i = s;
              var a = u.type, d = u.stateNode;
              if (!(u.flags & 128) && (typeof a.getDerivedStateFromError == "function" || d !== null && typeof d.componentDidCatch == "function" && (dt === null || !dt.has(d)))) {
                u.flags |= 65536, t &= -t, u.lanes |= t;
                var v = za(u, i, t);
                gi(u, v);
                break e;
              }
          }
          u = u.return;
        } while (u !== null);
      }
      Ya(n);
    } catch (x) {
      t = x, X === n && n !== null && (X = n = n.return);
      continue;
    }
    break;
  } while (!0);
}
function Qa() {
  var e = br.current;
  return br.current = qr, e === null ? qr : e;
}
function zo() {
  (Z === 0 || Z === 3 || Z === 2) && (Z = 4), b === null || !(Ot & 268435455) && !(ml & 268435455) || lt(b, ne);
}
function nl(e, t) {
  var n = R;
  R |= 2;
  var r = Qa();
  (b !== e || ne !== t) && (We = null, Pt(e, t));
  do
    try {
      md();
      break;
    } catch (l) {
      Wa(e, l);
    }
  while (!0);
  if (ao(), R = n, br.current = r, X !== null) throw Error(y(261));
  return b = null, ne = 0, Z;
}
function md() {
  for (; X !== null; ) Ka(X);
}
function hd() {
  for (; X !== null && !$c(); ) Ka(X);
}
function Ka(e) {
  var t = Ga(e.alternate, e, ge);
  e.memoizedProps = e.pendingProps, t === null ? Ya(e) : X = t, Eo.current = null;
}
function Ya(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (e = t.return, t.flags & 32768) {
      if (n = sd(n, t), n !== null) {
        n.flags &= 32767, X = n;
        return;
      }
      if (e !== null) e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
      else {
        Z = 6, X = null;
        return;
      }
    } else if (n = id(n, t, ge), n !== null) {
      X = n;
      return;
    }
    if (t = t.sibling, t !== null) {
      X = t;
      return;
    }
    X = t = e;
  } while (t !== null);
  Z === 0 && (Z = 5);
}
function Et(e, t, n) {
  var r = j, l = ze.transition;
  try {
    ze.transition = null, j = 1, vd(e, t, n, r);
  } finally {
    ze.transition = l, j = r;
  }
  return null;
}
function vd(e, t, n, r) {
  do
    tn();
  while (ot !== null);
  if (R & 6) throw Error(y(327));
  n = e.finishedWork;
  var l = e.finishedLanes;
  if (n === null) return null;
  if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(y(177));
  e.callbackNode = null, e.callbackPriority = 0;
  var u = n.lanes | n.childLanes;
  if (Gc(e, u), e === b && (X = b = null, ne = 0), !(n.subtreeFlags & 2064) && !(n.flags & 2064) || kr || (kr = !0, Za(Fr, function() {
    return tn(), null;
  })), u = (n.flags & 15990) !== 0, n.subtreeFlags & 15990 || u) {
    u = ze.transition, ze.transition = null;
    var o = j;
    j = 1;
    var i = R;
    R |= 4, Eo.current = null, cd(e, n), Va(n, e), If(hu), $r = !!mu, hu = mu = null, e.current = n, fd(n), Ac(), R = i, j = o, ze.transition = u;
  } else e.current = n;
  if (kr && (kr = !1, ot = e, tl = l), u = e.pendingLanes, u === 0 && (dt = null), Hc(n.stateNode), ye(e, K()), t !== null) for (r = e.onRecoverableError, n = 0; n < t.length; n++) l = t[n], r(l.value, { componentStack: l.stack, digest: l.digest });
  if (el) throw el = !1, e = Du, Du = null, e;
  return tl & 1 && e.tag !== 0 && tn(), u = e.pendingLanes, u & 1 ? e === Iu ? jn++ : (jn = 0, Iu = e) : jn = 0, wt(), null;
}
function tn() {
  if (ot !== null) {
    var e = Ps(tl), t = ze.transition, n = j;
    try {
      if (ze.transition = null, j = 16 > e ? 16 : e, ot === null) var r = !1;
      else {
        if (e = ot, ot = null, tl = 0, R & 6) throw Error(y(331));
        var l = R;
        for (R |= 4, E = e.current; E !== null; ) {
          var u = E, o = u.child;
          if (E.flags & 16) {
            var i = u.deletions;
            if (i !== null) {
              for (var s = 0; s < i.length; s++) {
                var c = i[s];
                for (E = c; E !== null; ) {
                  var h = E;
                  switch (h.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Rn(8, h, u);
                  }
                  var m = h.child;
                  if (m !== null) m.return = h, E = m;
                  else for (; E !== null; ) {
                    h = E;
                    var p = h.sibling, g = h.return;
                    if (Ua(h), h === c) {
                      E = null;
                      break;
                    }
                    if (p !== null) {
                      p.return = g, E = p;
                      break;
                    }
                    E = g;
                  }
                }
              }
              var k = u.alternate;
              if (k !== null) {
                var w = k.child;
                if (w !== null) {
                  k.child = null;
                  do {
                    var M = w.sibling;
                    w.sibling = null, w = M;
                  } while (w !== null);
                }
              }
              E = u;
            }
          }
          if (u.subtreeFlags & 2064 && o !== null) o.return = u, E = o;
          else e: for (; E !== null; ) {
            if (u = E, u.flags & 2048) switch (u.tag) {
              case 0:
              case 11:
              case 15:
                Rn(9, u, u.return);
            }
            var f = u.sibling;
            if (f !== null) {
              f.return = u.return, E = f;
              break e;
            }
            E = u.return;
          }
        }
        var a = e.current;
        for (E = a; E !== null; ) {
          o = E;
          var d = o.child;
          if (o.subtreeFlags & 2064 && d !== null) d.return = o, E = d;
          else e: for (o = a; E !== null; ) {
            if (i = E, i.flags & 2048) try {
              switch (i.tag) {
                case 0:
                case 11:
                case 15:
                  pl(9, i);
              }
            } catch (x) {
              Q(i, i.return, x);
            }
            if (i === o) {
              E = null;
              break e;
            }
            var v = i.sibling;
            if (v !== null) {
              v.return = i.return, E = v;
              break e;
            }
            E = i.return;
          }
        }
        if (R = l, wt(), Be && typeof Be.onPostCommitFiberRoot == "function") try {
          Be.onPostCommitFiberRoot(ul, e);
        } catch {
        }
        r = !0;
      }
      return r;
    } finally {
      j = n, ze.transition = t;
    }
  }
  return !1;
}
function $i(e, t, n) {
  t = sn(n, t), t = Pa(e, t, 1), e = ft(e, t, 1), t = ce(), e !== null && (qn(e, 1, t), ye(e, t));
}
function Q(e, t, n) {
  if (e.tag === 3) $i(e, e, n);
  else for (; t !== null; ) {
    if (t.tag === 3) {
      $i(t, e, n);
      break;
    } else if (t.tag === 1) {
      var r = t.stateNode;
      if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (dt === null || !dt.has(r))) {
        e = sn(n, e), e = za(t, e, 1), t = ft(t, e, 1), e = ce(), t !== null && (qn(t, 1, e), ye(t, e));
        break;
      }
    }
    t = t.return;
  }
}
function yd(e, t, n) {
  var r = e.pingCache;
  r !== null && r.delete(t), t = ce(), e.pingedLanes |= e.suspendedLanes & n, b === e && (ne & n) === n && (Z === 4 || Z === 3 && (ne & 130023424) === ne && 500 > K() - _o ? Pt(e, 0) : Co |= n), ye(e, t);
}
function Xa(e, t) {
  t === 0 && (e.mode & 1 ? (t = cr, cr <<= 1, !(cr & 130023424) && (cr = 4194304)) : t = 1);
  var n = ce();
  e = Je(e, t), e !== null && (qn(e, t, n), ye(e, n));
}
function gd(e) {
  var t = e.memoizedState, n = 0;
  t !== null && (n = t.retryLane), Xa(e, n);
}
function wd(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var r = e.stateNode, l = e.memoizedState;
      l !== null && (n = l.retryLane);
      break;
    case 19:
      r = e.stateNode;
      break;
    default:
      throw Error(y(314));
  }
  r !== null && r.delete(t), Xa(e, n);
}
var Ga;
Ga = function(e, t, n) {
  if (e !== null) if (e.memoizedProps !== t.pendingProps || he.current) me = !0;
  else {
    if (!(e.lanes & n) && !(t.flags & 128)) return me = !1, od(e, t, n);
    me = !!(e.flags & 131072);
  }
  else me = !1, A && t.flags & 1048576 && bs(t, Kr, t.index);
  switch (t.lanes = 0, t.tag) {
    case 2:
      var r = t.type;
      Lr(e, t), e = t.pendingProps;
      var l = rn(t, ie.current);
      en(t, n), l = go(null, t, r, e, l, n);
      var u = wo();
      return t.flags |= 1, typeof l == "object" && l !== null && typeof l.render == "function" && l.$$typeof === void 0 ? (t.tag = 1, t.memoizedState = null, t.updateQueue = null, ve(r) ? (u = !0, Wr(t)) : u = !1, t.memoizedState = l.state !== null && l.state !== void 0 ? l.state : null, po(t), l.updater = dl, t.stateNode = l, l._reactInternals = t, Cu(t, r, e, n), t = Pu(null, t, r, !0, u, n)) : (t.tag = 0, A && u && uo(t), ae(null, t, l, n), t = t.child), t;
    case 16:
      r = t.elementType;
      e: {
        switch (Lr(e, t), e = t.pendingProps, l = r._init, r = l(r._payload), t.type = r, l = t.tag = Sd(r), e = je(r, e), l) {
          case 0:
            t = Nu(null, t, r, e, n);
            break e;
          case 1:
            t = Ti(null, t, r, e, n);
            break e;
          case 11:
            t = Pi(null, t, r, e, n);
            break e;
          case 14:
            t = zi(null, t, r, je(r.type, e), n);
            break e;
        }
        throw Error(y(
          306,
          r,
          ""
        ));
      }
      return t;
    case 0:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : je(r, l), Nu(e, t, r, l, n);
    case 1:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : je(r, l), Ti(e, t, r, l, n);
    case 3:
      e: {
        if (Oa(t), e === null) throw Error(y(387));
        r = t.pendingProps, u = t.memoizedState, l = u.element, ua(e, t), Gr(t, r, null, n);
        var o = t.memoizedState;
        if (r = o.element, u.isDehydrated) if (u = { element: r, isDehydrated: !1, cache: o.cache, pendingSuspenseBoundaries: o.pendingSuspenseBoundaries, transitions: o.transitions }, t.updateQueue.baseState = u, t.memoizedState = u, t.flags & 256) {
          l = sn(Error(y(423)), t), t = Li(e, t, r, n, l);
          break e;
        } else if (r !== l) {
          l = sn(Error(y(424)), t), t = Li(e, t, r, n, l);
          break e;
        } else for (we = ct(t.stateNode.containerInfo.firstChild), ke = t, A = !0, De = null, n = ra(t, null, r, n), t.child = n; n; ) n.flags = n.flags & -3 | 4096, n = n.sibling;
        else {
          if (ln(), r === l) {
            t = qe(e, t, n);
            break e;
          }
          ae(e, t, r, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return oa(t), e === null && Su(t), r = t.type, l = t.pendingProps, u = e !== null ? e.memoizedProps : null, o = l.children, vu(r, l) ? o = null : u !== null && vu(r, u) && (t.flags |= 32), Ra(e, t), ae(e, t, o, n), t.child;
    case 6:
      return e === null && Su(t), null;
    case 13:
      return ja(e, t, n);
    case 4:
      return mo(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = un(t, null, r, n) : ae(e, t, r, n), t.child;
    case 11:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : je(r, l), Pi(e, t, r, l, n);
    case 7:
      return ae(e, t, t.pendingProps, n), t.child;
    case 8:
      return ae(e, t, t.pendingProps.children, n), t.child;
    case 12:
      return ae(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        if (r = t.type._context, l = t.pendingProps, u = t.memoizedProps, o = l.value, F(Yr, r._currentValue), r._currentValue = o, u !== null) if (Ue(u.value, o)) {
          if (u.children === l.children && !he.current) {
            t = qe(e, t, n);
            break e;
          }
        } else for (u = t.child, u !== null && (u.return = t); u !== null; ) {
          var i = u.dependencies;
          if (i !== null) {
            o = u.child;
            for (var s = i.firstContext; s !== null; ) {
              if (s.context === r) {
                if (u.tag === 1) {
                  s = Xe(-1, n & -n), s.tag = 2;
                  var c = u.updateQueue;
                  if (c !== null) {
                    c = c.shared;
                    var h = c.pending;
                    h === null ? s.next = s : (s.next = h.next, h.next = s), c.pending = s;
                  }
                }
                u.lanes |= n, s = u.alternate, s !== null && (s.lanes |= n), xu(
                  u.return,
                  n,
                  t
                ), i.lanes |= n;
                break;
              }
              s = s.next;
            }
          } else if (u.tag === 10) o = u.type === t.type ? null : u.child;
          else if (u.tag === 18) {
            if (o = u.return, o === null) throw Error(y(341));
            o.lanes |= n, i = o.alternate, i !== null && (i.lanes |= n), xu(o, n, t), o = u.sibling;
          } else o = u.child;
          if (o !== null) o.return = u;
          else for (o = u; o !== null; ) {
            if (o === t) {
              o = null;
              break;
            }
            if (u = o.sibling, u !== null) {
              u.return = o.return, o = u;
              break;
            }
            o = o.return;
          }
          u = o;
        }
        ae(e, t, l.children, n), t = t.child;
      }
      return t;
    case 9:
      return l = t.type, r = t.pendingProps.children, en(t, n), l = Te(l), r = r(l), t.flags |= 1, ae(e, t, r, n), t.child;
    case 14:
      return r = t.type, l = je(r, t.pendingProps), l = je(r.type, l), zi(e, t, r, l, n);
    case 15:
      return Ta(e, t, t.type, t.pendingProps, n);
    case 17:
      return r = t.type, l = t.pendingProps, l = t.elementType === r ? l : je(r, l), Lr(e, t), t.tag = 1, ve(r) ? (e = !0, Wr(t)) : e = !1, en(t, n), Na(t, r, l), Cu(t, r, l, n), Pu(null, t, r, !0, e, n);
    case 19:
      return Ma(e, t, n);
    case 22:
      return La(e, t, n);
  }
  throw Error(y(156, t.tag));
};
function Za(e, t) {
  return Es(e, t);
}
function kd(e, t, n, r) {
  this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
}
function Pe(e, t, n, r) {
  return new kd(e, t, n, r);
}
function To(e) {
  return e = e.prototype, !(!e || !e.isReactComponent);
}
function Sd(e) {
  if (typeof e == "function") return To(e) ? 1 : 0;
  if (e != null) {
    if (e = e.$$typeof, e === Yu) return 11;
    if (e === Xu) return 14;
  }
  return 2;
}
function mt(e, t) {
  var n = e.alternate;
  return n === null ? (n = Pe(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 14680064, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
}
function jr(e, t, n, r, l, u) {
  var o = 2;
  if (r = e, typeof e == "function") To(e) && (o = 1);
  else if (typeof e == "string") o = 5;
  else e: switch (e) {
    case $t:
      return zt(n.children, l, u, t);
    case Ku:
      o = 8, l |= 8;
      break;
    case Xl:
      return e = Pe(12, n, t, l | 2), e.elementType = Xl, e.lanes = u, e;
    case Gl:
      return e = Pe(13, n, t, l), e.elementType = Gl, e.lanes = u, e;
    case Zl:
      return e = Pe(19, n, t, l), e.elementType = Zl, e.lanes = u, e;
    case os:
      return hl(n, l, u, t);
    default:
      if (typeof e == "object" && e !== null) switch (e.$$typeof) {
        case ls:
          o = 10;
          break e;
        case us:
          o = 9;
          break e;
        case Yu:
          o = 11;
          break e;
        case Xu:
          o = 14;
          break e;
        case tt:
          o = 16, r = null;
          break e;
      }
      throw Error(y(130, e == null ? e : typeof e, ""));
  }
  return t = Pe(o, n, t, l), t.elementType = e, t.type = r, t.lanes = u, t;
}
function zt(e, t, n, r) {
  return e = Pe(7, e, r, t), e.lanes = n, e;
}
function hl(e, t, n, r) {
  return e = Pe(22, e, r, t), e.elementType = os, e.lanes = n, e.stateNode = { isHidden: !1 }, e;
}
function Ql(e, t, n) {
  return e = Pe(6, e, null, t), e.lanes = n, e;
}
function Kl(e, t, n) {
  return t = Pe(4, e.children !== null ? e.children : [], e.key, t), t.lanes = n, t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }, t;
}
function xd(e, t, n, r, l) {
  this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Nl(0), this.expirationTimes = Nl(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Nl(0), this.identifierPrefix = r, this.onRecoverableError = l, this.mutableSourceEagerHydrationData = null;
}
function Lo(e, t, n, r, l, u, o, i, s) {
  return e = new xd(e, t, n, i, s), t === 1 ? (t = 1, u === !0 && (t |= 8)) : t = 0, u = Pe(3, null, null, t), e.current = u, u.stateNode = e, u.memoizedState = { element: r, isDehydrated: n, cache: null, transitions: null, pendingSuspenseBoundaries: null }, po(u), e;
}
function Ed(e, t, n) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: Ut, key: r == null ? null : "" + r, children: e, containerInfo: t, implementation: n };
}
function Ja(e) {
  if (!e) return vt;
  e = e._reactInternals;
  e: {
    if (Dt(e) !== e || e.tag !== 1) throw Error(y(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (ve(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(y(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (ve(n)) return Js(e, n, t);
  }
  return t;
}
function qa(e, t, n, r, l, u, o, i, s) {
  return e = Lo(n, r, !0, e, l, u, o, i, s), e.context = Ja(null), n = e.current, r = ce(), l = pt(n), u = Xe(r, l), u.callback = t != null ? t : null, ft(n, u, l), e.current.lanes = l, qn(e, l, r), ye(e, r), e;
}
function vl(e, t, n, r) {
  var l = t.current, u = ce(), o = pt(l);
  return n = Ja(n), t.context === null ? t.context = n : t.pendingContext = n, t = Xe(u, o), t.payload = { element: e }, r = r === void 0 ? null : r, r !== null && (t.callback = r), e = ft(l, t, o), e !== null && (Fe(e, l, o, u), Pr(e, l, o)), o;
}
function rl(e) {
  if (e = e.current, !e.child) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function Ai(e, t) {
  if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function Ro(e, t) {
  Ai(e, t), (e = e.alternate) && Ai(e, t);
}
function Cd() {
  return null;
}
var ba = typeof reportError == "function" ? reportError : function(e) {
  console.error(e);
};
function Oo(e) {
  this._internalRoot = e;
}
yl.prototype.render = Oo.prototype.render = function(e) {
  var t = this._internalRoot;
  if (t === null) throw Error(y(409));
  vl(e, t, null, null);
};
yl.prototype.unmount = Oo.prototype.unmount = function() {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    jt(function() {
      vl(null, e, null, null);
    }), t[Ze] = null;
  }
};
function yl(e) {
  this._internalRoot = e;
}
yl.prototype.unstable_scheduleHydration = function(e) {
  if (e) {
    var t = Ls();
    e = { blockedOn: null, target: e, priority: t };
    for (var n = 0; n < rt.length && t !== 0 && t < rt[n].priority; n++) ;
    rt.splice(n, 0, e), n === 0 && Os(e);
  }
};
function jo(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
}
function gl(e) {
  return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11 && (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "));
}
function Vi() {
}
function _d(e, t, n, r, l) {
  if (l) {
    if (typeof r == "function") {
      var u = r;
      r = function() {
        var c = rl(o);
        u.call(c);
      };
    }
    var o = qa(t, r, e, 0, null, !1, !1, "", Vi);
    return e._reactRootContainer = o, e[Ze] = o.current, Bn(e.nodeType === 8 ? e.parentNode : e), jt(), o;
  }
  for (; l = e.lastChild; ) e.removeChild(l);
  if (typeof r == "function") {
    var i = r;
    r = function() {
      var c = rl(s);
      i.call(c);
    };
  }
  var s = Lo(e, 0, !1, null, null, !1, !1, "", Vi);
  return e._reactRootContainer = s, e[Ze] = s.current, Bn(e.nodeType === 8 ? e.parentNode : e), jt(function() {
    vl(t, s, n, r);
  }), s;
}
function wl(e, t, n, r, l) {
  var u = n._reactRootContainer;
  if (u) {
    var o = u;
    if (typeof l == "function") {
      var i = l;
      l = function() {
        var s = rl(o);
        i.call(s);
      };
    }
    vl(t, o, e, l);
  } else o = _d(n, t, e, l, r);
  return rl(o);
}
zs = function(e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = En(t.pendingLanes);
        n !== 0 && (Ju(t, n | 1), ye(t, K()), !(R & 6) && (an = K() + 500, wt()));
      }
      break;
    case 13:
      jt(function() {
        var r = Je(e, 1);
        if (r !== null) {
          var l = ce();
          Fe(r, e, 1, l);
        }
      }), Ro(e, 1);
  }
};
qu = function(e) {
  if (e.tag === 13) {
    var t = Je(e, 134217728);
    if (t !== null) {
      var n = ce();
      Fe(t, e, 134217728, n);
    }
    Ro(e, 134217728);
  }
};
Ts = function(e) {
  if (e.tag === 13) {
    var t = pt(e), n = Je(e, t);
    if (n !== null) {
      var r = ce();
      Fe(n, e, t, r);
    }
    Ro(e, t);
  }
};
Ls = function() {
  return j;
};
Rs = function(e, t) {
  var n = j;
  try {
    return j = e, t();
  } finally {
    j = n;
  }
};
ou = function(e, t, n) {
  switch (t) {
    case "input":
      if (bl(e, n), t = n.name, n.type === "radio" && t != null) {
        for (n = e; n.parentNode; ) n = n.parentNode;
        for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
          var r = n[t];
          if (r !== e && r.form === e.form) {
            var l = al(r);
            if (!l) throw Error(y(90));
            ss(r), bl(r, l);
          }
        }
      }
      break;
    case "textarea":
      cs(e, n);
      break;
    case "select":
      t = n.value, t != null && Zt(e, !!n.multiple, t, !1);
  }
};
ys = No;
gs = jt;
var Nd = { usingClientEntryPoint: !1, Events: [er, Ht, al, hs, vs, No] }, kn = { findFiberByHostInstance: Ct, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Pd = { bundleType: kn.bundleType, version: kn.version, rendererPackageName: kn.rendererPackageName, rendererConfig: kn.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: be.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
  return e = Ss(e), e === null ? null : e.stateNode;
}, findFiberByHostInstance: kn.findFiberByHostInstance || Cd, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined") {
  var Sr = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Sr.isDisabled && Sr.supportsFiber) try {
    ul = Sr.inject(Pd), Be = Sr;
  } catch {
  }
}
xe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Nd;
xe.createPortal = function(e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!jo(t)) throw Error(y(200));
  return Ed(e, t, null, n);
};
xe.createRoot = function(e, t) {
  if (!jo(e)) throw Error(y(299));
  var n = !1, r = "", l = ba;
  return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onRecoverableError !== void 0 && (l = t.onRecoverableError)), t = Lo(e, 1, !1, null, null, n, !1, r, l), e[Ze] = t.current, Bn(e.nodeType === 8 ? e.parentNode : e), new Oo(t);
};
xe.findDOMNode = function(e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == "function" ? Error(y(188)) : (e = Object.keys(e).join(","), Error(y(268, e)));
  return e = Ss(t), e = e === null ? null : e.stateNode, e;
};
xe.flushSync = function(e) {
  return jt(e);
};
xe.hydrate = function(e, t, n) {
  if (!gl(t)) throw Error(y(200));
  return wl(null, e, t, !0, n);
};
xe.hydrateRoot = function(e, t, n) {
  if (!jo(e)) throw Error(y(405));
  var r = n != null && n.hydratedSources || null, l = !1, u = "", o = ba;
  if (n != null && (n.unstable_strictMode === !0 && (l = !0), n.identifierPrefix !== void 0 && (u = n.identifierPrefix), n.onRecoverableError !== void 0 && (o = n.onRecoverableError)), t = qa(t, null, e, 1, n != null ? n : null, l, !1, u, o), e[Ze] = t.current, Bn(e), r) for (e = 0; e < r.length; e++) n = r[e], l = n._getVersion, l = l(n._source), t.mutableSourceEagerHydrationData == null ? t.mutableSourceEagerHydrationData = [n, l] : t.mutableSourceEagerHydrationData.push(
    n,
    l
  );
  return new yl(t);
};
xe.render = function(e, t, n) {
  if (!gl(t)) throw Error(y(200));
  return wl(null, e, t, !1, n);
};
xe.unmountComponentAtNode = function(e) {
  if (!gl(e)) throw Error(y(40));
  return e._reactRootContainer ? (jt(function() {
    wl(null, null, e, !1, function() {
      e._reactRootContainer = null, e[Ze] = null;
    });
  }), !0) : !1;
};
xe.unstable_batchedUpdates = No;
xe.unstable_renderSubtreeIntoContainer = function(e, t, n, r) {
  if (!gl(n)) throw Error(y(200));
  if (e == null || e._reactInternals === void 0) throw Error(y(38));
  return wl(e, t, n, !1, r);
};
xe.version = "18.3.1-next-f1338f8080-20240426";
function ec() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ == "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(ec);
    } catch (e) {
      console.error(e);
    }
}
ec(), es.exports = xe;
var zd = es.exports, tc, Bi = zd;
tc = Bi.createRoot, Bi.hydrateRoot;
window.process = window.process || { env: { NODE_ENV: "production" } };
const Td = `
:host {display:block;font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,"Helvetica Neue",Arial;}
.panel{background:#f5eadf;border-radius:12px;border:1px solid #eadccd;padding:16px;}
.panel h3{margin:0 0 6px;font-size:20px;font-weight:700;}
.panel p.subtle{margin:0 0 16px;font-size:13px;line-height:1.35;color:#6b6b6b;}
.grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
@media(max-width:700px){.grid{grid-template-columns:1fr;}}
.card{background:#fff;border:1px solid #e8e2db;border-radius:12px;min-height:240px;display:flex;align-items:center;justify-content:center;position:relative;}
.card.blank{background:none;border:none;box-shadow:none;}
.upload-tile{cursor:pointer;user-select:none;text-align:center;padding:20px;}
.plus{font-size:36px;line-height:1;font-weight:500;color:#b7b0a8;}
.upload-label{display:block;margin-top:6px;font-size:14px;color:#9a9288;}
.preview{position:absolute;inset:0;overflow:hidden;border-radius:12px;}
.preview img{width:100%;height:100%;object-fit:cover;}
.right-inner{width:100%;height:100%;display:grid;place-items:center;}
.cta,.modal button{border:none;border-radius:10px;padding:12px 18px;font-weight:600;font-size:16px;background:#3a8494;color:#fff;cursor:pointer;opacity:1;transition:background .2s ease,transform .1s ease;}
.cta:hover:not([disabled]),.modal button:hover{transform:scale(1.02);}
.cta[disabled]{opacity:.6;cursor:not-allowed;}
.limit-text{margin-top:8px;font-size:13px;color:#5b5b5b;text-align:center;}
.help{position:absolute;bottom:10px;left:12px;right:12px;font-size:11px;color:#8a8580;text-align:center;}
.modal-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;z-index:9999;}
.modal{background:#fff;border-radius:12px;padding:12px;max-width:90%;max-height:90%;display:flex;flex-direction:column;align-items:center;}
.modal img{max-width:100%;border-radius:8px;margin-bottom:12px;}
.modal-actions{display:flex;gap:12px;}
.visually-hidden{position:absolute!important;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px);white-space:nowrap;}
`;
function Ld({ attrs: e, host: t }) {
  const n = Ce.useRef(null), [r, l] = Ce.useState(null), [u, o] = Ce.useState(""), [i, s] = Ce.useState(""), [c, h] = Ce.useState(!1), [m, p] = Ce.useState(""), [g, k] = Ce.useState(!1), [w, M] = Ce.useState(null), [f, a] = Ce.useState(null), d = async () => {
    var I;
    try {
      const Y = await fetch(`${e.proxyEndpoint}?checkLimit=1`, { method: "GET" });
      if (!Y.ok) return;
      const ee = await Y.json();
      typeof ee.remaining != "undefined" && (M(ee.remaining), a((I = ee.max) != null ? I : 5));
    } catch (Y) {
      console.warn("Limit check failed", Y);
    }
  };
  Ce.useEffect(() => {
    d();
  }, []);
  const v = (I) => {
    var ee, Re;
    const Y = (Re = (ee = I.target.files) == null ? void 0 : ee[0]) != null ? Re : null;
    p(""), s(""), l(Y), o(Y ? URL.createObjectURL(Y) : "");
  }, x = async () => {
    var nr, It;
    if (w !== null && w <= 0) {
      p("You have exhausted your daily limit.");
      return;
    }
    if (!r) return p("Please upload a photo first.");
    h(!0), p("");
    const I = new AbortController(), Y = setTimeout(() => I.abort(), 45e3), ee = {
      id: e.productId,
      title: e.productTitle,
      category: e.category
    }, Re = new FormData();
    Re.set("image", r, r.name || "upload.jpg"), Re.set("productImageUrl", e.mediaUrl || ""), Re.set("product", JSON.stringify(ee));
    try {
      const se = await fetch(e.proxyEndpoint, {
        method: "POST",
        mode: "cors",
        body: Re,
        signal: I.signal
      });
      if (clearTimeout(Y), !se.ok) {
        const D = await se.text();
        p(`Try-on failed (${se.status}): ${D}`);
        return;
      }
      const S = await se.json(), P = (nr = S == null ? void 0 : S.result) == null ? void 0 : nr.imageBase64, z = ((It = S == null ? void 0 : S.result) == null ? void 0 : It.mime) || "image/jpeg";
      if (!P) {
        p("No image returned by model.");
        return;
      }
      s(`data:${z};base64,${P}`), M((D) => typeof D == "number" ? D - 1 : D);
    } catch (se) {
      (se == null ? void 0 : se.name) === "AbortError" ? p("Request timed out. Please try again.") : p(`Something went wrong: ${(se == null ? void 0 : se.message) || ""}`);
    } finally {
      clearTimeout(Y), h(!1);
    }
  }, C = () => {
    l(null), o(""), s(""), p(""), h(!1), n.current && (n.current.value = "");
  }, _ = () => k(!0), N = () => k(!1), V = () => {
    if (!i) return;
    const I = document.createElement("a");
    I.href = i, I.download = "sashel-tryon.jpg", I.click();
  }, T = async () => {
    try {
      const Y = await (await fetch(i)).blob(), ee = new File([Y], "sashel-tryon.jpg", { type: Y.type });
      navigator.canShare && navigator.canShare({ files: [ee] }) ? await navigator.share({ files: [ee], text: "Check out what I tried on today at sashel.in!", title: "Sashel Try-On" }) : (await navigator.clipboard.writeText(i), alert("Link copied! Paste in WhatsApp."));
    } catch {
      alert("Sharing failed.");
    }
  };
  return /* @__PURE__ */ O.jsxs("div", { className: "panel", children: [
    /* @__PURE__ */ O.jsx("h3", { children: "Try On The Product With Your Outfit" }),
    /* @__PURE__ */ O.jsx("p", { className: "subtle", children: "For accurate results, upload a close-shot photo from waist up. Images are simulated using AI and could make mistakes. These are meant solely for better visualisation." }),
    i ? /* @__PURE__ */ O.jsxs("div", { className: "grid", children: [
      /* @__PURE__ */ O.jsx("div", { className: "card", onClick: _, style: { cursor: "pointer" }, children: /* @__PURE__ */ O.jsx("div", { className: "preview", children: /* @__PURE__ */ O.jsx("img", { src: i, alt: "Generated result" }) }) }),
      /* @__PURE__ */ O.jsx("div", { className: "card blank", children: /* @__PURE__ */ O.jsx("button", { className: "cta", onClick: C, children: "Reset uploaded photo" }) })
    ] }) : /* @__PURE__ */ O.jsxs("div", { className: "grid", children: [
      /* @__PURE__ */ O.jsxs("div", { className: "card", children: [
        /* @__PURE__ */ O.jsxs("label", { className: "upload-tile", children: [
          /* @__PURE__ */ O.jsx("span", { className: "plus", children: "+" }),
          /* @__PURE__ */ O.jsx("span", { className: "upload-label", children: "Upload photo" }),
          /* @__PURE__ */ O.jsx("input", { ref: n, type: "file", accept: "image/*", className: "visually-hidden", onChange: v })
        ] }),
        u && /* @__PURE__ */ O.jsx("div", { className: "preview", children: /* @__PURE__ */ O.jsx("img", { src: u, alt: "Preview" }) })
      ] }),
      /* @__PURE__ */ O.jsx("div", { className: "card blank", children: /* @__PURE__ */ O.jsxs("div", { className: "right-inner", children: [
        /* @__PURE__ */ O.jsx("button", { className: "cta", disabled: !r || c || w !== null && w <= 0, onClick: x, children: c ? "Processing…" : "Try On Now" }),
        w !== null && f !== null && /* @__PURE__ */ O.jsx("div", { className: "limit-text", children: w > 0 ? `Tries left: ${w} / ${f}` : "You have exhausted your daily limit." })
      ] }) })
    ] }),
    g && /* @__PURE__ */ O.jsx("div", { className: "modal-backdrop", onClick: N, children: /* @__PURE__ */ O.jsxs("div", { className: "modal", onClick: (I) => I.stopPropagation(), children: [
      /* @__PURE__ */ O.jsx("img", { src: i, alt: "Result" }),
      /* @__PURE__ */ O.jsxs("div", { className: "modal-actions", children: [
        /* @__PURE__ */ O.jsx("button", { onClick: V, children: "Download" }),
        /* @__PURE__ */ O.jsx("button", { onClick: T, children: "Share on WhatsApp" }),
        /* @__PURE__ */ O.jsx("button", { onClick: N, children: "Close" })
      ] })
    ] }) })
  ] });
}
class Rd extends HTMLElement {
  constructor() {
    super(), this.shadowRootEl = this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    const t = document.createElement("style");
    t.textContent = Td;
    const n = document.createElement("div");
    this.shadowRootEl.innerHTML = "", this.shadowRootEl.append(t, n);
    const r = {
      productId: this.getAttribute("data-product-id") || "",
      productTitle: this.getAttribute("data-product-title") || "",
      mediaUrl: this.getAttribute("data-media-url") || "",
      category: this.getAttribute("data-category") || "",
      earringDesignText: this.getAttribute("data-earring-design-text") || "",
      neckpieceDesignText: this.getAttribute("data-neckpiece-design-text") || "",
      bodyPartText: this.getAttribute("data-body-part-text") || "",
      proxyEndpoint: this.getAttribute("data-proxy-endpoint") || ""
    };
    this.reactRoot = tc(n), this.reactRoot.render(/* @__PURE__ */ O.jsx(Ld, { attrs: r, host: this }));
  }
  disconnectedCallback() {
    var t;
    (t = this.reactRoot) == null || t.unmount();
  }
}
customElements.get("sashel-tryon") || customElements.define("sashel-tryon", Rd);
